const { store, ActionCreators, EventTypes, Popover, Modal } = __app__;
const { Swiper } = window;

import './style.scss';

export class JCCatalogElementEShop24
{
	constructor(arParams)
	{
		this.productType = 0;

		this.config = {
			useCatalog: true,
			showQuantity: true,
			showPrice: true,
			showAbsent: true,
			showOldPrice: false,
			showPercent: false,
			showSkuProps: false,
			showOfferGroup: false,
			useCompare: false,
			useStickers: false,
			useSubscribe: false,
			usePopup: false,
			useMagnifier: false,
			usePriceRanges: false,
			basketAction: ['BUY'],
			showClosePopup: false,
			templateTheme: '',
			showSlider: false,
			sliderInterval: 5000,
			useEnhancedEcommerce: false,
			dataLayerName: 'dataLayer',
			brandProperty: false,
			alt: '',
			title: '',
			magnifierZoomPercent: 200,
			buy1ClickUrl: '',
			productFeedbackUrl: '',
			useFavorite: false,
			useFeedback: false,
		};

		this.checkQuantity = false;
		this.maxQuantity = 0;
		this.minQuantity = 0;
		this.stepQuantity = 1;
		this.isDblQuantity = false;
		this.canBuy = true;
		this.isGift = false;
		this.canSubscription = true;
		this.currentIsSet = false;
		this.updateViewedCount = false;

		this.currentPriceMode = '';
		this.currentPrices = [];
		this.currentPriceSelected = 0;
		this.currentQuantityRanges = [];
		this.currentQuantityRangeSelected = 0;

		this.precision = 6;
		this.precisionFactor = Math.pow(10, this.precision);

		this.visual = {};
		this.basketMode = '';
		this.product = {
			checkQuantity: false,
			maxQuantity: 0,
			stepQuantity: 1,
			startQuantity: 1,
			isDblQuantity: false,
			canBuy: true,
			canSubscription: true,
			name: '',
			pict: {},
			id: 0,
			addUrl: '',
			buyUrl: '',
			slider: {},
			sliderCount: 0,
			useSlider: false,
			sliderPict: [],
			measure: '',
		};
		this.mess = {};

		this.basketData = {
			useProps: false,
			emptyProps: false,
			quantity: 'quantity',
			props: 'prop',
			basketUrl: '',
			sku_props: '',
			sku_props_var: 'basket_props',
			add_url: '',
			buy_url: ''
		};
		this.compareData = {
			compareUrl: '',
			compareDeleteUrl: '',
			comparePath: ''
		};

		this.favoriteData = {
			favoritePath: ''
		};

		this.feedbackData = {
			feedbackPath: ''
		};

		this.defaultPict = {
			preview: null,
			detail: null
		};

		this.offers = [];
		this.offerNum = 0;
		this.treeProps = [];
		this.selectedValues = {};

		this.mouseTimer = null;
		this.isTouchDevice = BX.hasClass(document.documentElement, 'bx-touch');
		this.touch = null;
		this.slider = {
			interval: null,
			progress: null,
			paused: null,
			controls: []
		};

		this.quantityDelay = null;
		this.quantityTimer = null;

		this.obProduct = null;
		this.obQuantity = null;
		this.obQuantityUp = null;
		this.obQuantityDown = null;
		this.obPrice = {
			bonus: null,
			price: null,
			full: null,
			discount: null,
			percent: null,
			total: null
		};
		this.obTree = null;
		this.obPriceRanges = null;
		this.obBuyBtn = null;
		this.obAddToBasketBtn = null;
		this.obBasketActions = null;
		this.obFavorite = null;
		this.obFeedbackBtn = null;
		// this.obProductNav = null;
		// this.obCheaperBtn = null;
		this.obProductFeedbackBtn = null;
		this.obBuy1clickBtn = null;
		this.obNotAvail = null;
		this.obSubscribe = null;
		this.obSkuProps = null;
		this.obPreviewText = null;
		this.obDescription = null;
		this.obMainSkuProps = null;
		this.obBigSlider = null;
		this.obMeasure = null;
		this.obQuantityLimit = {
			all: null,
			value: null
		};
		this.obCompare = null;
		this.obTabsPanel = null;

		this.node = {};
		// top panel small card
		this.smallCardNodes = {};

		this.magnify = {
			enabled: false,
			obBigImg: null,
			obBigSlider: null,
			height: 0,
			width: 0,
			timer: 0
		};
		this.currentImg = {
			id: 0,
			src: '',
			width: 0,
			height: 0
		};
		this.viewedCounter = {
			path: '/bitrix/components/bitrix/catalog.element/ajax.php',
			params: {
				AJAX: 'Y',
				SITE_ID: '',
				PRODUCT_ID: 0,
				PARENT_ID: 0
			}
		};

		this.obPopupWin = null;
		this.basketUrl = '';
		this.basketParams = {};

		this.errorCode = 0;

		if (typeof arParams === 'object')
		{
			this.params = arParams;
			this.initConfig();

			if (this.params.MESS)
			{
				this.mess = this.params.MESS;
			}

			switch (this.productType)
			{
				case 0: // no catalog
				case 1: // product
				case 2: // set
					this.initProductData();

					this.slides = this.product.sliderPict;
					break;
				case 3: // sku
					this.initOffersData();
					break;
				default:
					this.errorCode = -1;
			}

			this.initBasketData();
			this.initCompareData();
		}

		if (this.errorCode === 0)
		{
			BX.ready(BX.delegate(this.init, this));
		}

		this.params = {};

		BX.addCustomEvent('onSaleProductIsGift', BX.delegate(this.onSaleProductIsGift, this));
		BX.addCustomEvent('onSaleProductIsNotGift', BX.delegate(this.onSaleProductIsNotGift, this));
	}

		getEntity(parent, entity, additionalFilter)
		{
			if (!parent || !entity)
				return null;

			additionalFilter = additionalFilter || '';

			return parent.querySelector(additionalFilter + '[data-entity="' + entity + '"]');
		}

		getEntities(parent, entity, additionalFilter)
		{
			if (!parent || !entity)
				return {length: 0};

			additionalFilter = additionalFilter || '';

			return parent.querySelectorAll(additionalFilter + '[data-entity="' + entity + '"]');
		}

		onSaleProductIsGift(productId, offerId)
		{
			if (offerId && this.offers && this.offers[this.offerNum].ID == offerId)
			{
				this.setGift();
			}
		}

		onSaleProductIsNotGift(productId, offerId)
		{
			if (offerId && this.offers && this.offers[this.offerNum].ID == offerId)
			{
				this.restoreSticker();
				this.isGift = false;
				this.setPrice();
			}
		}

		reloadGiftInfo()
		{
			if (this.productType === 3)
			{
				this.checkQuantity = true;
				this.maxQuantity = 1;

				this.setPrice();
				this.redrawSticker({text: BX.message('PRODUCT_GIFT_LABEL')});
			}
		}

		setGift()
		{
			if (this.productType === 3)
			{
				// sku
				this.isGift = true;
			}

			if (this.productType === 1 || this.productType === 2)
			{
				// simple
				this.isGift = true;
			}

			if (this.productType === 0)
			{
				this.isGift = false;
			}

			this.reloadGiftInfo();
		}

		setOffer(offerNum)
		{
			this.offerNum = parseInt(offerNum);
			this.setCurrent();
		}

		init()
		{
			var i = 0,
				j = 0,
				treeItems = null;

			this.obProduct = BX(this.visual.ID);
			if (!this.obProduct)
			{
				this.errorCode = -1;
			}

			this.obBigSlider = BX(this.visual.BIG_SLIDER_ID);
			this.node.imageContainer = this.getEntity(this.obProduct, 'images-container');
			this.node.imageSliderBlock = this.getEntity(this.obProduct, 'images-slider-block');
/*
			this.node.sliderProgressBar = this.getEntity(this.obProduct, 'slider-progress-bar');
			this.node.sliderControlLeft = this.getEntity(this.obBigSlider, 'slider-control-left');
			this.node.sliderControlRight = this.getEntity(this.obBigSlider, 'slider-control-right');
*/

			if (!this.obBigSlider || !this.node.imageContainer || !this.node.imageContainer)
			{
				this.errorCode = -2;
			}

			if (this.config.showPrice)
			{
				this.obPrice.price = BX(this.visual.PRICE_ID);
/*
				if (!this.obPrice.price && this.config.useCatalog)
				{
					this.errorCode = -16;
				}
				else
				{
*/
					this.obPrice.total = BX(this.visual.PRICE_TOTAL);
/*
					if (this.config.showOldPrice)
					{
						this.obPrice.full = BX(this.visual.OLD_PRICE_ID);
						this.obPrice.discount = BX(this.visual.DISCOUNT_PRICE_ID);

						if (!this.obPrice.full || !this.obPrice.discount)
						{
							this.config.showOldPrice = false;
						}
					}

					if (this.config.showPercent)
					{
						this.obPrice.percent = BX(this.visual.DISCOUNT_PERCENT_ID);
						if (!this.obPrice.percent)
						{
							this.config.showPercent = false;
						}
					}
				}
*/

				this.obBasketActions = BX(this.visual.BASKET_ACTIONS_ID);
				if (this.obBasketActions)
				{
					if (BX.util.in_array('BUY', this.config.basketAction))
					{
						this.obBuyBtn = BX(this.visual.BUY_LINK);
					}

					if (BX.util.in_array('ADD', this.config.basketAction))
					{
						this.obAddToBasketBtn = BX(this.visual.ADD_BASKET_LINK);
					}
				}
				this.obNotAvail = BX(this.visual.NOT_AVAILABLE_MESS);
			}

			if (this.config.showQuantity)
			{
				this.obQuantity = BX(this.visual.QUANTITY_ID);
				this.node.quantity = this.getEntity(this.obProduct, 'quantity-block');
				if (this.visual.QUANTITY_UP_ID)
				{
					this.obQuantityUp = BX(this.visual.QUANTITY_UP_ID);
				}

				if (this.visual.QUANTITY_DOWN_ID)
				{
					this.obQuantityDown = BX(this.visual.QUANTITY_DOWN_ID);
				}
			}

			if (this.productType === 3)
			{
				if (this.visual.TREE_ID)
				{
					this.obTree = BX(this.visual.TREE_ID);
					if (!this.obTree)
					{
						this.errorCode = -256;
					}
				}

				if (this.visual.QUANTITY_MEASURE)
				{
					this.obMeasure = BX(this.visual.QUANTITY_MEASURE);
				}

				if (this.visual.QUANTITY_LIMIT && this.config.showMaxQuantity !== 'N')
				{
					this.obQuantityLimit.all = BX(this.visual.QUANTITY_LIMIT);
					if (this.obQuantityLimit.all)
					{
						this.obQuantityLimit.value = this.getEntity(this.obQuantityLimit.all, 'quantity-limit-value');
						if (!this.obQuantityLimit.value)
						{
							this.obQuantityLimit.all = null;
						}
					}
				}

				if (this.config.usePriceRanges)
				{
					this.obPriceRanges = this.getEntity(this.obProduct, 'price-ranges-block');
				}
			}

			if (this.config.showSkuProps)
			{
				this.obSkuProps = BX(this.visual.DISPLAY_PROP_DIV);
				this.obMainSkuProps = BX(this.visual.DISPLAY_MAIN_PROP_DIV);
			}

			if (this.config.showSkuDescription === 'Y')
			{
				this.obPreviewText = BX(this.visual.PREVIEW_TEXT_ID);
				this.obDescription = BX(this.visual.DESCRIPTION_ID);
			}

			if (this.config.useCompare)
			{
				this.obCompare = BX(this.visual.COMPARE_LINK);
			}

			if (this.config.useSubscribe)
			{
				this.obSubscribe = BX(this.visual.SUBSCRIBE_LINK);
			}

			this.obTabs = BX(this.visual.TABS_ID);

			if (this.config.usePopup)
			{
				this.node.imageContainer.style.cursor = 'zoom-in';
				this.node.imageContainer.addEventListener(
					'click',
					this.showMainPictPopup.bind(this)
				);
			}

			if (this.config.useMagnifier)
			{
				this.node.imageContainer.addEventListener(
					'mouseover',
					this.enableMagnifier.bind(this)
				);
			}

			if (this.config.useFavorite)
			{
				this.obFavorite = BX(this.visual.FAVORITE_ID);
			}

			if (this.config.useFeedback)
			{
				this.obFeedbackBtn = BX(this.visual.FEEDBACK_LINK);
			}

			if (this.visual.BUY1CLICK_ID)
			{
				this.obBuy1clickBtn = BX(this.visual.BUY1CLICK_ID);
			}

			if (this.visual.ACTION_FEEDBACK_LINK)
			{
				this.obProductFeedbackBtn = BX(this.visual.ACTION_FEEDBACK_LINK);
			}

			this.obSaleBanner = BX(this.visual.SALE_BANNER);
			if (this.obSaleBanner)
			{
				BX.addCustomEvent('onTimerStart', BX.delegate(this.showSaleBanner, this));
				BX.addCustomEvent('onTimerEnd', BX.delegate(this.hideSaleBanner, this));
			}

			if (this.config.fillAllPrices)
			{
				this.obPricesAll = BX(this.visual.PRICES_CONTAINER);
			}

			if (this.errorCode === 0)
			{
/*
				// product slider events
				if (this.config.showSlider && !this.isTouchDevice)
				{
					BX.bind(this.obBigSlider, 'mouseenter', BX.proxy(this.stopSlider, this));
					BX.bind(this.obBigSlider, 'mouseleave', BX.proxy(this.cycleSlider, this));
				}

				if (this.isTouchDevice)
				{
					BX.bind(this.node.imageContainer, 'touchstart', BX.proxy(this.touchStartEvent, this));
					BX.bind(this.node.imageContainer, 'touchend', BX.proxy(this.touchEndEvent, this));
					BX.bind(this.node.imageContainer, 'touchcancel', BX.proxy(this.touchEndEvent, this));
				}

				BX.bind(this.node.sliderControlLeft, 'click', BX.proxy(this.slidePrev, this));
				BX.bind(this.node.sliderControlRight, 'click', BX.proxy(this.slideNext, this));
*/

				if (this.config.showQuantity)
				{
					var startEventName = this.isTouchDevice ? 'touchstart' : 'mousedown';
					var endEventName = this.isTouchDevice ? 'touchend' : 'mouseup';

					if (this.obQuantityUp)
					{
						BX.bind(this.obQuantityUp, startEventName, BX.proxy(this.startQuantityInterval, this));
						BX.bind(this.obQuantityUp, endEventName, BX.proxy(this.clearQuantityInterval, this));
						BX.bind(this.obQuantityUp, 'mouseout', BX.proxy(this.clearQuantityInterval, this));
						BX.bind(this.obQuantityUp, 'click', BX.delegate(this.quantityUp, this));
					}

					if (this.obQuantityDown)
					{
						BX.bind(this.obQuantityDown, startEventName, BX.proxy(this.startQuantityInterval, this));
						BX.bind(this.obQuantityDown, endEventName, BX.proxy(this.clearQuantityInterval, this));
						BX.bind(this.obQuantityDown, 'mouseout', BX.proxy(this.clearQuantityInterval, this));
						BX.bind(this.obQuantityDown, 'click', BX.delegate(this.quantityDown, this));
					}

					if (this.obQuantity)
					{
						BX.bind(this.obQuantity, 'change', BX.delegate(this.quantityChange, this));
					}
				}

				switch (this.productType)
				{
					case 0: // no catalog
					case 1: // product
					case 2: // set
						if (this.product.useSlider)
						{
							this.product.slider = {
								CONT: BX(this.visual.SLIDER_CONT_ID),
							};

							if (this.slides.length > 1)
							{
								this.initSlider();
							}
						}
						this.checkQuantityControls();
						this.setAnalyticsDataLayer('showDetail');
						break;
					case 3: // sku
						treeItems = this.obTree.querySelectorAll('li');
						for (i = 0; i < treeItems.length; i++)
						{
							BX.bind(treeItems[i], 'click', BX.delegate(this.selectOfferProp, this));
						}

						this.product.slider = {
							ID: this.visual.SLIDER_CONT_ID,
							CONT: BX(this.visual.SLIDER_CONT_ID)
						};

						this.setCurrent();
						if (this.obQuantity)
						{
							this.checkPriceRange(this.obQuantity.value);
							this.checkQuantityControls();
						}

						if (this.offers[this.offerNum].SLIDER_COUNT > 1)
						{
							this.initSlider();
						}
						break;
				}

				this.obBuyBtn && BX.bind(this.obBuyBtn, 'click', BX.proxy(this.buyBasket, this));
				// this.smallCardNodes.buyButton && BX.bind(this.smallCardNodes.buyButton, 'click', BX.proxy(this.buyBasket, this));

				this.obAddToBasketBtn && BX.bind(this.obAddToBasketBtn, 'click', BX.proxy(this.add2Basket, this));
				// this.smallCardNodes.addButton && BX.bind(this.smallCardNodes.addButton, 'click', BX.proxy(this.add2Basket, this));

				if (this.obBasketActions)
				{
					store.subscribe(EventTypes.CART_UPDATED, event => {
						this.setCartStatus(event.data.itemId);
					});
				}

				if (this.obCompare)
				{
					BX.bind(this.obCompare, 'click', BX.proxy(this.compare, this));
					if (this.obCompare)
					{
						BX.bind(this.obCompare, 'click', BX.proxy(this.compare, this));
						this.obCompare.addEventListener(
							'keydown',
							(event) => {
								if (event.code === 'Enter' || event.code === 'NumpadEnter')
								{
									this.compare(event);
								}
							},
							true
						);
					}

					BX.addCustomEvent('onCatalogDeleteCompare', BX.proxy(this.checkDeletedCompare, this));

					store.subscribe(EventTypes.COMPARE_UPDATED, event => {
						this.setCompareStatus(event.data.itemId);
					});
				}

				if (this.config.useFavorite)
				{
					if (this.obFavorite)
					{
						BX.bind(this.obFavorite, 'click', BX.proxy(this.favoriteAction, this));
						this.obFavorite.addEventListener(
							'keydown',
							(event) => {
								if (event.code === 'Enter' || event.code === 'NumpadEnter')
								{
									this.favoriteAction(event);
								}
							},
							true
						);

						store.subscribe(EventTypes.WISHLIST_UPDATED, event => {
							this.setFavoriteStatus(event.data.itemId);
						});

						this.setFavoriteStatus();
					}
				}

				this.setCartStatus();

				if (this.obBuy1clickBtn)
				{
					BX.bind(this.obBuy1clickBtn, 'click', BX.proxy(this.buy1Click, this));
				}

				if (this.obFeedbackBtn)
				{
					this.obFeedbackBtn.addEventListener('click', BX.proxy(this.showFeedbackForm, this));
				}
			}
		}

		initConfig()
		{
			if (this.params.PRODUCT_TYPE)
			{
				this.productType = parseInt(this.params.PRODUCT_TYPE, 10);
			}

			if (this.params.CONFIG.USE_CATALOG !== 'undefined' && BX.type.isBoolean(this.params.CONFIG.USE_CATALOG))
			{
				this.config.useCatalog = this.params.CONFIG.USE_CATALOG;
			}

			this.config.showQuantity = this.params.CONFIG.SHOW_QUANTITY;
			this.config.showPrice = this.params.CONFIG.SHOW_PRICE;
			this.config.showPercent = this.params.CONFIG.SHOW_DISCOUNT_PERCENT;
			this.config.showOldPrice = this.params.CONFIG.SHOW_OLD_PRICE;
			this.config.showSkuProps = this.params.CONFIG.SHOW_SKU_PROPS;
			this.config.showOfferGroup = this.params.CONFIG.OFFER_GROUP;
			this.config.useCompare = this.params.CONFIG.DISPLAY_COMPARE;
			this.config.useStickers = this.params.CONFIG.USE_STICKERS;
			this.config.useSubscribe = this.params.CONFIG.USE_SUBSCRIBE;
			this.config.showMaxQuantity = this.params.CONFIG.SHOW_MAX_QUANTITY;
			this.config.relativeQuantityFactor = parseInt(this.params.CONFIG.RELATIVE_QUANTITY_FACTOR);
			this.config.usePriceRanges = this.params.CONFIG.USE_PRICE_COUNT;
			this.config.showSkuDescription = this.params.CONFIG.SHOW_SKU_DESCRIPTION;
			this.config.displayPreviewTextMode = this.params.CONFIG.DISPLAY_PREVIEW_TEXT_MODE;
			this.config.useFavorite = this.params.CONFIG.USE_FAVORITE;
			this.config.useFeedback = this.params.CONFIG.USE_FEEDBACK;
			this.config.fillAllPrices = this.params.CONFIG.FILL_ITEM_ALL_PRICES;

			if (this.params.CONFIG.MAIN_PICTURE_MODE)
			{
				this.config.usePopup = BX.util.in_array('POPUP', this.params.CONFIG.MAIN_PICTURE_MODE);
				this.config.useMagnifier = BX.util.in_array('MAGNIFIER', this.params.CONFIG.MAIN_PICTURE_MODE);
			}

			if (this.params.CONFIG.ADD_TO_BASKET_ACTION)
			{
				this.config.basketAction = this.params.CONFIG.ADD_TO_BASKET_ACTION;
			}

			this.config.showClosePopup = this.params.CONFIG.SHOW_CLOSE_POPUP;
			this.config.templateTheme = this.params.CONFIG.TEMPLATE_THEME || '';
			this.config.showSlider = this.params.CONFIG.SHOW_SLIDER === 'Y';

/*
			if (this.config.showSlider && !this.isTouchDevice)
			{
				this.config.sliderInterval = parseInt(this.params.CONFIG.SLIDER_INTERVAL) || 5000;
			}
			else
			{
				this.config.sliderInterval = false;
			}
*/

			this.config.useEnhancedEcommerce = this.params.CONFIG.USE_ENHANCED_ECOMMERCE === 'Y';
			this.config.dataLayerName = this.params.CONFIG.DATA_LAYER_NAME;
			this.config.brandProperty = this.params.CONFIG.BRAND_PROPERTY;

			this.config.alt = this.params.CONFIG.ALT || '';
			this.config.title = this.params.CONFIG.TITLE || '';

			// this.config.magnifierZoomPercent = parseInt(this.params.CONFIG.MAGNIFIER_ZOOM_PERCENT) || 200;

			if (!this.params.VISUAL || typeof this.params.VISUAL !== 'object' || !this.params.VISUAL.ID)
			{
				this.errorCode = -1;
				return;
			}

			this.visual = this.params.VISUAL;

			this.mess = this.params.MESS;

			if (this.params.CONFIG.LINK_BUY1CLICK)
			{
				this.config.buy1ClickUrl = this.params.CONFIG.LINK_BUY1CLICK;
			}

			if (this.config.useFavorite)
			{
				if (this.params.FAVORITE && typeof this.params.FAVORITE === 'object')
				{
					if (this.params.FAVORITE.FAVORITE_PATH)
					{
						this.favoriteData.favoritePath = this.params.FAVORITE.FAVORITE_PATH;
					}
				}

			}

			if (this.config.useFeedback)
			{
				if (this.params.FEEDBACK && typeof this.params.FEEDBACK === 'object')
				{
					if (this.params.FEEDBACK.FEEDBACK_PATH)
					{
						this.feedbackData.feedbackPath = this.params.FEEDBACK.FEEDBACK_PATH;
					}
				}
			}
		}

		initProductData()
		{
			var j = 0;

			if (this.params.PRODUCT && typeof this.params.PRODUCT === 'object')
			{
				if (this.config.showPrice)
				{
					this.currentPriceMode = this.params.PRODUCT.ITEM_PRICE_MODE;
					this.currentPrices = this.params.PRODUCT.ITEM_PRICES;
					this.currentAllPrices = this.params.PRODUCT.ITEM_ALL_PRICES;
					this.currentPriceSelected = this.params.PRODUCT.ITEM_PRICE_SELECTED;
					this.currentQuantityRanges = this.params.PRODUCT.ITEM_QUANTITY_RANGES;
					this.currentQuantityRangeSelected = this.params.PRODUCT.ITEM_QUANTITY_RANGE_SELECTED;
				}

				if (this.config.showQuantity)
				{
					this.product.checkQuantity = this.params.PRODUCT.CHECK_QUANTITY;
					this.product.isDblQuantity = this.params.PRODUCT.QUANTITY_FLOAT;

					if (this.product.checkQuantity)
					{
						this.product.maxQuantity = this.product.isDblQuantity
							? parseFloat(this.params.PRODUCT.MAX_QUANTITY)
							: parseInt(this.params.PRODUCT.MAX_QUANTITY, 10);
					}

					this.product.stepQuantity = this.product.isDblQuantity
						? parseFloat(this.params.PRODUCT.STEP_QUANTITY)
						: parseInt(this.params.PRODUCT.STEP_QUANTITY, 10);
					this.checkQuantity = this.product.checkQuantity;
					this.isDblQuantity = this.product.isDblQuantity;
					this.stepQuantity = this.product.stepQuantity;
					this.maxQuantity = this.product.maxQuantity;
					this.minQuantity = this.currentPriceMode === 'Q' ? parseFloat(this.currentPrices[this.currentPriceSelected].MIN_QUANTITY) : this.stepQuantity;

					if (this.isDblQuantity)
					{
						this.stepQuantity = Math.round(this.stepQuantity * this.precisionFactor) / this.precisionFactor;
					}
				}

				this.product.canBuy = this.params.PRODUCT.CAN_BUY;
				this.canSubscription = this.product.canSubscription = this.params.PRODUCT.SUBSCRIPTION;

				this.product.name = this.params.PRODUCT.NAME;
				this.product.pict = this.params.PRODUCT.PICT;
				this.product.id = this.params.PRODUCT.ID;
				this.product.category = this.params.PRODUCT.CATEGORY;
				this.product.measure = this.params.PRODUCT.MEASURE;

				if (this.params.PRODUCT.ADD_URL)
				{
					this.product.addUrl = this.params.PRODUCT.ADD_URL;
				}

				if (this.params.PRODUCT.BUY_URL)
				{
					this.product.buyUrl = this.params.PRODUCT.BUY_URL;
				}

				if (this.params.PRODUCT.SLIDER_COUNT)
				{
					this.product.sliderCount = parseInt(this.params.PRODUCT.SLIDER_COUNT, 10) || 0;

					if (this.product.sliderCount > 0 && this.params.PRODUCT.SLIDER.length)
					{
						this.product.useSlider = true;

						for (j = 0; j < this.params.PRODUCT.SLIDER.length; j++)
						{
							this.product.useSlider = true;
							this.params.PRODUCT.SLIDER[j].WIDTH = parseInt(this.params.PRODUCT.SLIDER[j].WIDTH, 10);
							this.params.PRODUCT.SLIDER[j].HEIGHT = parseInt(this.params.PRODUCT.SLIDER[j].HEIGHT, 10);
						}

						this.product.sliderPict = this.params.PRODUCT.SLIDER;
/*
						this.setCurrentImg(this.product.sliderPict[0], false);
*/
					}
				}

				this.currentIsSet = true;
			}
			else
			{
				this.errorCode = -1;
			}
		}

		initOffersData()
		{
			if (this.params.OFFERS && BX.type.isArray(this.params.OFFERS))
			{
				this.offers = this.params.OFFERS;
				this.offerNum = 0;

				if (this.params.OFFER_SELECTED)
				{
					this.offerNum = parseInt(this.params.OFFER_SELECTED, 10) || 0;
				}

				if (this.params.TREE_PROPS)
				{
					this.treeProps = this.params.TREE_PROPS;
				}

				if (this.params.DEFAULT_PICTURE)
				{
					this.defaultPict.preview = this.params.DEFAULT_PICTURE.PREVIEW_PICTURE;
					this.defaultPict.detail = this.params.DEFAULT_PICTURE.DETAIL_PICTURE;
				}

				if (this.params.PRODUCT && typeof this.params.PRODUCT === 'object')
				{
					this.product.id = parseInt(this.params.PRODUCT.ID, 10);
					this.product.name = this.params.PRODUCT.NAME;
					this.product.category = this.params.PRODUCT.CATEGORY;
					this.product.detailText = this.params.PRODUCT.DETAIL_TEXT;
					this.product.detailTextType = this.params.PRODUCT.DETAIL_TEXT_TYPE;
					this.product.previewText = this.params.PRODUCT.PREVIEW_TEXT;
					this.product.previewTextType = this.params.PRODUCT.PREVIEW_TEXT_TYPE;
				}

				for (let i = 0; i < this.offers.length; i++)
				{
					this.offers[i].SLIDER_COUNT = parseInt(this.offers[i].SLIDER_COUNT, 10) || 0;
				}

				this.offerInit(this.offers[this.offerNum]);
			}
			else
			{
				this.errorCode = -1;
			}
		}

		initBasketData()
		{
			if (this.params.BASKET && typeof this.params.BASKET === 'object')
			{
				if (this.productType === 1 || this.productType === 2)
				{
					this.basketData.useProps = this.params.BASKET.ADD_PROPS;
					this.basketData.emptyProps = this.params.BASKET.EMPTY_PROPS;
				}

				if (this.params.BASKET.QUANTITY)
				{
					this.basketData.quantity = this.params.BASKET.QUANTITY;
				}

				if (this.params.BASKET.PROPS)
				{
					this.basketData.props = this.params.BASKET.PROPS;
				}

				if (this.params.BASKET.BASKET_URL)
				{
					this.basketData.basketUrl = this.params.BASKET.BASKET_URL;
				}

				if (this.productType === 3)
				{
					if (this.params.BASKET.SKU_PROPS)
					{
						this.basketData.sku_props = this.params.BASKET.SKU_PROPS;
					}
				}

				if (this.params.BASKET.ADD_URL_TEMPLATE)
				{
					this.basketData.add_url = this.params.BASKET.ADD_URL_TEMPLATE;
				}

				if (this.params.BASKET.BUY_URL_TEMPLATE)
				{
					this.basketData.buy_url = this.params.BASKET.BUY_URL_TEMPLATE;
				}

				if (this.basketData.add_url === '' && this.basketData.buy_url === '')
				{
					this.errorCode = -1024;
				}
			}
		}

		initCompareData()
		{
			if (this.config.useCompare)
			{
				if (this.params.COMPARE && typeof this.params.COMPARE === 'object')
				{
					if (this.params.COMPARE.COMPARE_PATH)
					{
						this.compareData.comparePath = this.params.COMPARE.COMPARE_PATH;
					}

					if (this.params.COMPARE.COMPARE_URL_TEMPLATE)
					{
						this.compareData.compareUrl = this.params.COMPARE.COMPARE_URL_TEMPLATE;
					}
					else
					{
						this.config.useCompare = false;
					}

					if (this.params.COMPARE.COMPARE_DELETE_URL_TEMPLATE)
					{
						this.compareData.compareDeleteUrl = this.params.COMPARE.COMPARE_DELETE_URL_TEMPLATE;
					}
					else
					{
						this.config.useCompare = false;
					}
				}
				else
				{
					this.config.useCompare = false;
				}
			}
		}

		initSlider()
		{
			this.product.slider.instance = new Swiper(this.node.imageSliderBlock, {
				slidesPerView: 1,
				breakpoints: {},
				autoHeight: true,
				loop: true,
				spaceBetween: 0,
				speed: 300,
				pagination: {
					el: this.product.slider.CONT,
					type: 'bullets',
					bulletElement: 'button',
					clickable: true,
					bulletClass: 'product-item-slider-control',
					bulletActiveClass: 'active',
					renderBullet: function (index, className) {
						const slide = this.slides.filter(slide => !slide.classList.contains(this.params.slideDuplicateClass))[index];

						return '<div class="product-item-slider-control" data-entity="slider-control"><button class="product-item-slider-controls-image">'
							+ '<img src="'+ (slide.getAttribute('data-thumb'))+'" alt="">'
							+ '</button></div>';
					},
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				on: {
					update: function () {

						if (!this.originalParams.loop)
							return;

						const slides = this.slides.filter(slide => !slide.classList.contains(this.params.slideDuplicateClass));

						if (this.params.loop && slides.length <= this.params.slidesPerView)
						{
							this.params.loop = false;
							this.params.pagination = false;
							this.loopDestroy();
							this.updateSlides();
						}
						else if (!this.params.loop && slides.length > this.params.slidesPerView)
						{
							this.params.loop = this.originalParams.loop;
							this.params.pagination = this.originalParams.pagination;
							this.loopDestroy();
							this.loopCreate();
							this.updateSlides();
						}
					}
				},
			});
		}

		setAnalyticsDataLayer(action)
		{
			if (!this.config.useEnhancedEcommerce || !this.config.dataLayerName)
				return;

			var item = {},
				info = {},
				variants = [],
				i, k, j, propId, skuId, propValues;

			switch (this.productType)
			{
				case 0: //no catalog
				case 1: //product
				case 2: //set
					item = {
						'id': this.product.id,
						'name': this.product.name,
						'price': this.currentPrices[this.currentPriceSelected] && this.currentPrices[this.currentPriceSelected].PRICE,
						'category': this.product.category,
						'brand': BX.type.isArray(this.config.brandProperty) ? this.config.brandProperty.join('/') : this.config.brandProperty
					};
					break;
				case 3: //sku
					for (i in this.offers[this.offerNum].TREE)
					{
						if (this.offers[this.offerNum].TREE.hasOwnProperty(i))
						{
							propId = i.substring(5);
							skuId = this.offers[this.offerNum].TREE[i];

							for (k in this.treeProps)
							{
								if (this.treeProps.hasOwnProperty(k) && this.treeProps[k].ID == propId)
								{
									for (j in this.treeProps[k].VALUES)
									{
										propValues = this.treeProps[k].VALUES[j];
										if (propValues.ID == skuId)
										{
											variants.push(propValues.NAME);
											break;
										}
									}

								}
							}
						}
					}

					item = {
						'id': this.offers[this.offerNum].ID,
						'name': this.offers[this.offerNum].NAME,
						'price': this.currentPrices[this.currentPriceSelected] && this.currentPrices[this.currentPriceSelected].PRICE,
						'category': this.product.category,
						'brand': BX.type.isArray(this.config.brandProperty) ? this.config.brandProperty.join('/') : this.config.brandProperty,
						'variant': variants.join('/')
					};
					break;
			}

			switch (action)
			{
				case 'showDetail':
					info = {
						'event': 'showDetail',
						'ecommerce': {
							'currencyCode': this.currentPrices[this.currentPriceSelected] && this.currentPrices[this.currentPriceSelected].CURRENCY || '',
							'detail': {
								'products': [{
									'name': item.name || '',
									'id': item.id || '',
									'price': item.price || 0,
									'brand': item.brand || '',
									'category': item.category || '',
									'variant': item.variant || ''
								}]
							}
						}
					};
					break;
				case 'addToCart':
					info = {
						'event': 'addToCart',
						'ecommerce': {
							'currencyCode': this.currentPrices[this.currentPriceSelected] && this.currentPrices[this.currentPriceSelected].CURRENCY || '',
							'add': {
								'products': [{
									'name': item.name || '',
									'id': item.id || '',
									'price': item.price || 0,
									'brand': item.brand || '',
									'category': item.category || '',
									'variant': item.variant || '',
									'quantity': this.config.showQuantity && this.obQuantity ? this.obQuantity.value : 1
								}]
							}
						}
					};
					break;
			}

			window[this.config.dataLayerName] = window[this.config.dataLayerName] || [];
			window[this.config.dataLayerName].push(info);
		}

		setCurrentImg(img, showImage, showPanelImage)
		{
			var images, l;

			this.currentImg.id = img.ID;
			this.currentImg.src = img.SRC;
			this.currentImg.width = img.WIDTH;
			this.currentImg.height = img.HEIGHT;

			if (showImage && this.node.imageContainer)
			{
				images = this.getEntities(this.node.imageContainer, 'image');
				l = images.length;
				while (l--)
				{
					if (images[l].getAttribute('data-id') == img.ID)
					{
						if (!BX.hasClass(images[l], 'active'))
						{
							this.node.sliderProgressBar && this.resetProgress();
						}

						BX.addClass(images[l], 'active');
					}
					else if (BX.hasClass(images[l], 'active'))
					{
						BX.removeClass(images[l], 'active');
					}
				}
			}

			if (this.config.useMagnifier && !this.isTouchDevice)
			{
				this.setMagnifierParams();

				if (showImage)
				{
					this.disableMagnifier(true);
				}
			}
		}

		enableMagnifier(event)
		{
			event.stopPropagation();

			const { target } = event,
				currentSlide = BX.findParent(target, {attribute: {'data-entity': 'image'}});

			if (this.magnify.enabled || !currentSlide)
				return;

			const img = currentSlide.querySelector('img'),
				index = parseInt(currentSlide.getAttribute('data-index'), 10);

			this.currentImg.img = img;
			this.currentImg.src = this.slides[index].SRC;
			this.currentImg.width = this.slides[index].WIDTH;
			this.currentImg.height = this.slides[index].HEIGHT;

			let element = currentSlide.querySelector('.product-item-slider-image-zoom');
			if (!element)
			{
				element = document.createElement('div');
				element.classList.add('product-item-slider-image-zoom');
				element.innerHTML = `
					<div class="product-item-slider-image-zoom-loader">
						<div class="spinner-border text-primary" role="status">
							<span class="sr-only">Loading</span>
						</div>
					</div>
				`;
				img.parentNode.appendChild(element);
			}

			element.style.display = 'none';
			element.style.width = this.magnify.width = img.width + 'px';
			element.style.height = this.magnify.height = img.height + 'px';
			element.style.display = '';
			this.currentImg.node = element;

			var image = new Image();
			image.onload = () => {
				element.classList.add('is-loaded');

				element.style.backgroundImage = 'url(\'' + this.currentImg.src + '\')';
				element.firstElementChild.style.opacity = 0;
				this.showMagnifier();
			}
			image.src = this.currentImg.src;

			BX.bind(document, 'mousemove', BX.proxy(this.moveMagnifierArea, this));
		}

		disableMagnifier(animateSize)
		{
			if (!this.magnify.enabled)
				return;

			clearTimeout(this.magnify.timer);
			BX.removeClass(this.obBigSlider, 'magnified');
			this.magnify.enabled = false;

			this.currentImg.node.style.backgroundSize = '100% auto';
			if (animateSize)
			{
				// set initial size for css animation
				this.currentImg.node.style.height = this.magnify.height + 'px';
				this.currentImg.node.style.width = this.magnify.width + 'px';

				this.magnify.timer = setTimeout(
					BX.delegate(function(){
						this.currentImg.node.style.opacity = '';
						this.currentImg.node.style.height = this.currentImg.img.height;
						this.currentImg.node.style.width = this.currentImg.img.width;
					}, this),
					250
				);
			}
			else
			{
				this.currentImg.node.style.opacity = '';
				this.currentImg.node.style.height = this.currentImg.img.height;
				this.currentImg.node.style.width = this.currentImg.img.width;
			}

			BX.unbind(document, 'mousemove', BX.proxy(this.moveMagnifierArea, this));
		}

		moveMagnifierArea(e)
		{
			var posBigImg = BX.pos(this.currentImg.node),
				currentPos = this.inRect(e, posBigImg);

			if (this.inBound(posBigImg, currentPos))
			{
				var space = 60,
					currentImgStyle = getComputedStyle(this.currentImg.node),
					posPercentX, posPercentY;

				if (currentPos.X < space)
					posPercentX = 0;
				else if (parseInt(currentImgStyle.width, 10) - currentPos.X < space)
					posPercentX = 100;
				else
					posPercentX = (currentPos.X - space) / (parseInt(currentImgStyle.width, 10) - space * 2) * 100;

				if (currentPos.Y < space)
					posPercentY = 0;
				else if (parseInt(currentImgStyle.height, 10) - currentPos.Y < space)
					posPercentY = 100;
				else
					posPercentY = (currentPos.Y - space) / (parseInt(currentImgStyle.height, 10) - space * 2) * 100;

				this.currentImg.node.style.backgroundPosition = posPercentX + '% ' + posPercentY + '%';

				if (!this.magnify.enabled)
				{
					this.showMagnifier();
				}
			}
			else
			{
				this.disableMagnifier(true);
			}
		}

		showMagnifier()
		{
			var resolution, sliderWidth, w, h, zoomPercent;

			clearTimeout(this.magnify.timer);
			BX.addClass(this.obBigSlider, 'magnified');

			// set initial size for css animation
			this.currentImg.node.style.height = (this.magnify.height = this.currentImg.node.clientHeight) + 'px';
			this.currentImg.node.style.width = (this.magnify.width = this.currentImg.node.offsetWidth) + 'px';

			resolution = this.currentImg.width / this.currentImg.height;
			sliderWidth = this.obBigSlider.offsetWidth;

			if (sliderWidth > this.currentImg.width)
			{
				w = sliderWidth;
				h = w / resolution;
				zoomPercent = 100;
			}
			else
			{
				w = this.currentImg.width;
				h = this.currentImg.height;
				zoomPercent = this.currentImg.width / this.magnify.width * 100;
			}

			// base64 transparent pixel
			this.currentImg.node.style.backgroundSize = zoomPercent + '% auto';

			// set target size
			this.magnify.timer = setTimeout(BX.delegate(function(){
					this.currentImg.node.style.height = h + 'px';
					this.currentImg.node.style.width = w + 'px';
				}, this),
				10
			);

			this.magnify.enabled = true;
		}

		inBound(rect, point)
		{
			return (
				(point.Y >= 0 && rect.height >= point.Y)
				&& (point.X >= 0 && rect.width >= point.X)
			);
		}

		inRect(e, rect)
		{
			var wndSize = BX.GetWindowSize(),
				currentPos = {
					X: 0,
					Y: 0,
					globalX: 0,
					globalY: 0
				};

			currentPos.globalX = e.clientX + wndSize.scrollLeft;

			if (e.offsetX && e.offsetX < 0)
			{
				currentPos.globalX -= e.offsetX;
			}

			currentPos.X = currentPos.globalX - rect.left;
			currentPos.globalY = e.clientY + wndSize.scrollTop;

			if (e.offsetY && e.offsetY < 0)
			{
				currentPos.globalY -= e.offsetY;
			}

			currentPos.Y = currentPos.globalY - rect.top;

			return currentPos;
		}

		showMainPictPopup(event)
		{
			const { target } = event;

			const currentSlide = target.closest('.swiper-slide-active[data-entity="image"]');
			let options = {
				index: parseInt(currentSlide.getAttribute('data-index'), 10),
			}

			const gallery = new Gallery(options);
			gallery.slides = this.slides;

			gallery.open();
		}

		startQuantityInterval()
		{
			var target = BX.proxy_context;
			var func = target.id === this.visual.QUANTITY_DOWN_ID
				? BX.proxy(this.quantityDown, this)
				: BX.proxy(this.quantityUp, this);

			this.quantityDelay = setTimeout(
				BX.delegate(function() {
					this.quantityTimer = setInterval(func, 150);
				}, this),
				300
			);
		}

		clearQuantityInterval()
		{
			clearTimeout(this.quantityDelay);
			clearInterval(this.quantityTimer);
		}

		quantityUp()
		{
			var curValue = 0,
				boolSet = true;

			if (this.errorCode === 0 && this.config.showQuantity && this.canBuy && !this.isGift)
			{
				curValue = this.isDblQuantity ? parseFloat(this.obQuantity.value) : parseInt(this.obQuantity.value, 10);
				if (!isNaN(curValue))
				{
					curValue += this.stepQuantity;

					curValue = this.checkQuantityRange(curValue, 'up');

					if (this.checkQuantity && curValue > this.maxQuantity)
					{
						boolSet = false;
					}

					if (boolSet)
					{
						if (this.isDblQuantity)
						{
							curValue = Math.round(curValue * this.precisionFactor) / this.precisionFactor;
						}

						this.obQuantity.value = curValue;

						this.setPrice();
					}
				}
			}
		}

		quantityDown()
		{
			var curValue = 0,
				boolSet = true;

			if (this.errorCode === 0 && this.config.showQuantity && this.canBuy && !this.isGift)
			{
				curValue = (this.isDblQuantity ? parseFloat(this.obQuantity.value) : parseInt(this.obQuantity.value, 10));
				if (!isNaN(curValue))
				{
					curValue -= this.stepQuantity;

					curValue = this.checkQuantityRange(curValue, 'down');

					if (curValue < this.minQuantity)
					{
						boolSet = false;
					}

					if (boolSet)
					{
						if (this.isDblQuantity)
						{
							curValue = Math.round(curValue * this.precisionFactor) / this.precisionFactor;
						}

						this.obQuantity.value = curValue;

						this.setPrice();
					}
				}
			}
		}

		quantityChange()
		{
			var curValue = 0,
				intCount;

			if (this.errorCode === 0 && this.config.showQuantity)
			{
				if (this.canBuy)
				{
					curValue = this.isDblQuantity ? parseFloat(this.obQuantity.value) : Math.round(this.obQuantity.value);
					if (!isNaN(curValue))
					{
						curValue = this.checkQuantityRange(curValue);

						if (this.checkQuantity)
						{
							if (curValue > this.maxQuantity)
							{
								curValue = this.maxQuantity;
							}
						}

						this.checkPriceRange(curValue);

						intCount = Math.floor(
							Math.round(curValue * this.precisionFactor / this.stepQuantity) / this.precisionFactor
						) || 1;
						curValue = (intCount <= 1 ? this.stepQuantity : intCount * this.stepQuantity);
						curValue = Math.round(curValue * this.precisionFactor) / this.precisionFactor;

						if (curValue < this.minQuantity)
						{
							curValue = this.minQuantity;
						}

						this.obQuantity.value = curValue;
					}
					else
					{
						this.obQuantity.value = this.minQuantity;
					}
				}
				else
				{
					this.obQuantity.value = this.minQuantity;
				}

				this.setPrice();
			}
		}

		quantitySet(index)
		{
			var strLimit, resetQuantity;

			var newOffer = this.offers[index],
				oldOffer = this.offers[this.offerNum];

			if (this.errorCode === 0)
			{
				this.offerInit(newOffer);

				if (this.canBuy)
				{
					this.node.quantity && BX.style(this.node.quantity, 'display', '');

					this.obBasketActions && BX.style(this.obBasketActions, 'display', '');
					this.obBuy1clickBtn && BX.style(this.obBuy1clickBtn, 'display', '');
					// this.smallCardNodes.buyButton && BX.style(this.smallCardNodes.buyButton, 'display', '');
					// this.smallCardNodes.addButton && BX.style(this.smallCardNodes.addButton, 'display', '');

					// this.obNotAvail && BX.style(this.obNotAvail, 'display', 'none');
					// this.smallCardNodes.notAvailableButton && BX.style(this.smallCardNodes.notAvailableButton, 'display', 'none');

					this.obSubscribe && BX.style(this.obSubscribe, 'display', 'none');
				}
				else
				{
					this.node.quantity && BX.style(this.node.quantity, 'display', 'none');

					this.obBasketActions && BX.style(this.obBasketActions, 'display', 'none');
					this.obBuy1clickBtn && BX.style(this.obBuy1clickBtn, 'display', 'none');
					// this.smallCardNodes.buyButton && BX.style(this.smallCardNodes.buyButton, 'display', 'none');
					// this.smallCardNodes.addButton && BX.style(this.smallCardNodes.addButton, 'display', 'none');

					// this.obNotAvail && BX.style(this.obNotAvail, 'display', '');
					// this.smallCardNodes.notAvailableButton && BX.style(this.smallCardNodes.notAvailableButton, 'display', '');

					if (this.obSubscribe)
					{
						if (newOffer.CATALOG_SUBSCRIBE === 'Y')
						{
							BX.style(this.obSubscribe, 'display', '');
							this.obSubscribe.setAttribute('data-item', newOffer.ID);
							BX(this.visual.SUBSCRIBE_LINK + '_hidden').click();
						}
						else
						{
							BX.style(this.obSubscribe, 'display', 'none');
						}
					}
				}

				if (!this.canBuy || (this.checkQuantity && this.maxQuantity == 0))
				{
					this.obNotAvail && BX.style(this.obNotAvail, 'display', '');
				}
				else
				{
					this.obNotAvail && BX.style(this.obNotAvail, 'display', 'none');
				}

				if (this.config.showQuantity)
				{
					var isDifferentMinQuantity = oldOffer.ITEM_PRICES.length
						&& oldOffer.ITEM_PRICES[oldOffer.ITEM_PRICE_SELECTED]
						&& oldOffer.ITEM_PRICES[oldOffer.ITEM_PRICE_SELECTED].MIN_QUANTITY != this.minQuantity;

					if (this.isDblQuantity)
					{
						resetQuantity = Math.round(parseFloat(oldOffer.STEP_QUANTITY) * this.precisionFactor) / this.precisionFactor !== this.stepQuantity
							|| isDifferentMinQuantity
							|| oldOffer.MEASURE !== newOffer.MEASURE
							|| (
								this.checkQuantity
								&& parseFloat(oldOffer.MAX_QUANTITY) > this.maxQuantity
								&& parseFloat(this.obQuantity.value) > this.maxQuantity
							);
					}
					else
					{
						resetQuantity = parseInt(oldOffer.STEP_QUANTITY, 10) !== this.stepQuantity
							|| isDifferentMinQuantity
							|| oldOffer.MEASURE !== newOffer.MEASURE
							|| (
								this.checkQuantity
								&& parseInt(oldOffer.MAX_QUANTITY, 10) > this.maxQuantity
								&& parseInt(this.obQuantity.value, 10) > this.maxQuantity
							);
					}

					this.obQuantity.disabled = !this.canBuy;

					if (resetQuantity)
					{
						this.obQuantity.value = this.minQuantity;
					}

					if (this.obMeasure)
					{
						if (newOffer.MEASURE)
						{
							BX.adjust(this.obMeasure, {html: newOffer.MEASURE});
						}
						else
						{
							BX.adjust(this.obMeasure, {html: ''});
						}
					}
				}

				if (this.obQuantityLimit.all)
				{
					if (!this.canBuy || !this.checkQuantity || this.maxQuantity == 0)
					{
						BX.adjust(this.obQuantityLimit.value, {html: ''});
						BX.adjust(this.obQuantityLimit.all, {style: {display: 'none'}});
					}
					else
					{
						if (this.config.showMaxQuantity === 'M')
						{
							strLimit = (this.maxQuantity / this.stepQuantity >= this.config.relativeQuantityFactor)
								? BX.message('RELATIVE_QUANTITY_MANY')
								: BX.message('RELATIVE_QUANTITY_FEW');
						}
						else
						{
							strLimit = this.maxQuantity;

							if (newOffer.MEASURE)
							{
								strLimit += (' ' + newOffer.MEASURE);
							}
						}

						BX.adjust(this.obQuantityLimit.value, {html: strLimit});
						BX.adjust(
							this.obQuantityLimit.all,
							{
								attrs: {
									className: (this.maxQuantity / this.stepQuantity >= this.config.relativeQuantityFactor)
									? 'product-item-limit is-instock'
									: 'product-item-limit is-limited',
								},
								style: {display: ''}
							}
						);
					}
				}

				if (this.config.usePriceRanges)
				{
					if (!!this.config.fillAllPrices)
					{
						var priceNodes = this.getEntities(this.obProduct, 'price-ranges'),
							showPriceCount = 0;

						for (var j in priceNodes)
						{
							if (priceNodes.hasOwnProperty(j) && BX.type.isDomNode(priceNodes[j]))
							{
								var priceTypeId = priceNodes[j].getAttribute('data-price-id');

								if (this.currentPriceMode === 'Q' && newOffer.PRICE_RANGES_HTML[priceTypeId])
								{
									var rangesBody = this.getEntity(priceNodes[j], 'price-ranges-body');

									if (rangesBody)
									{
										rangesBody.innerHTML = newOffer.PRICE_RANGES_HTML[priceTypeId];
									}

									priceNodes[j].style.display = '';
									showPriceCount++;
								}
								else
								{
									priceNodes[j].style.display = 'none';
								}
							}
						}

						if (this.obPricesAll)
						{
							var obTabLink = this.obTabs.querySelector('#tab_price');
							if (showPriceCount > 0)
							{
								this.obPricesAll.style.display = '';
								if (obTabLink)
									obTabLink.parentNode.style.display = ''
							}
							else
							{
								this.obPricesAll.style.display = 'none';
								if (obTabLink)
								{
									obTabLink.parentNode.style.display = 'none';
									if (obTabLink.classList.contains('active'))
									{
										this.obTabs.querySelector('[data-toggle="tab"]').click();
									}
								}
							}
						}
					}
					else
					{

				if (this.config.usePriceRanges && this.obPriceRanges)
				{
					var priceTypeId = this.currentPrices[this.currentPriceSelected].PRICE_TYPE_ID;
					if (
						this.currentPriceMode === 'Q'
						&& newOffer.PRICE_RANGES_HTML
					)
					{
						var rangesBody = this.getEntity(this.obPriceRanges, 'price-ranges-body'),
							rangesRatioHeader = this.getEntity(this.obPriceRanges, 'price-ranges-ratio-header');

						if (rangesBody)
						{
							rangesBody.innerHTML = newOffer.PRICE_RANGES_HTML[priceTypeId];
						}

						if (rangesRatioHeader)
						{
							rangesRatioHeader.innerHTML = newOffer.PRICE_RANGES_RATIO_HTML;
						}

						this.obPriceRanges.style.display = '';
					}
					else
					{
						this.obPriceRanges.style.display = 'none';
					}

				}
					}
				}
			}
		}

		selectOfferProp()
		{
			var i = 0,
				strTreeValue = '',
				arTreeItem = [],
				rowItems = null,
				target = BX.proxy_context,
				smallCardItem;

			if (target && target.hasAttribute('data-treevalue'))
			{
				if (BX.hasClass(target, 'checked'))
					return;

				if (typeof document.activeElement === 'object')
				{
					document.activeElement.blur();
				}

				strTreeValue = target.getAttribute('data-treevalue');
				arTreeItem = strTreeValue.split('_');
				this.searchOfferPropIndex(arTreeItem[0], arTreeItem[1]);
				rowItems = BX.findChildren(target.parentNode, {tagName: 'li'}, false);

				if (rowItems && rowItems.length)
				{
					for (i = 0; i < rowItems.length; i++)
					{
						BX.removeClass(rowItems[i], 'checked');
					}
				}

				BX.addClass(target, 'checked');
				this.setOfferCurrentValue(BX.findParent(target, {attribute: {'data-entity': 'sku-line-block'}}), target);
			}
		}

		searchOfferPropIndex(strPropID, strPropValue)
		{
			var strName = '',
				arShowValues = false,
				arCanBuyValues = [],
				allValues = [],
				index = -1,
				i, j,
				arFilter = {},
				tmpFilter = [];

			for (i = 0; i < this.treeProps.length; i++)
			{
				if (this.treeProps[i].ID === strPropID)
				{
					index = i;
					break;
				}
			}

			if (index > -1)
			{
				for (i = 0; i < index; i++)
				{
					strName = 'PROP_' + this.treeProps[i].ID;
					arFilter[strName] = this.selectedValues[strName];
				}

				strName = 'PROP_' + this.treeProps[index].ID;
				arFilter[strName] = strPropValue;

				for (i = index + 1; i < this.treeProps.length; i++)
				{
					strName = 'PROP_' + this.treeProps[i].ID;
					arShowValues = this.getRowValues(arFilter, strName);

					if (!arShowValues)
						break;

					allValues = [];

					if (this.config.showAbsent)
					{
						arCanBuyValues = [];
						tmpFilter = [];
						tmpFilter = BX.clone(arFilter, true);

						for (j = 0; j < arShowValues.length; j++)
						{
							tmpFilter[strName] = arShowValues[j];
							allValues[allValues.length] = arShowValues[j];
							if (this.getCanBuy(tmpFilter))
								arCanBuyValues[arCanBuyValues.length] = arShowValues[j];
						}
					}
					else
					{
						arCanBuyValues = arShowValues;
					}

					if (this.selectedValues[strName] && BX.util.in_array(this.selectedValues[strName], arCanBuyValues))
					{
						arFilter[strName] = this.selectedValues[strName];
					}
					else
					{
						if (this.config.showAbsent)
						{
							arFilter[strName] = (arCanBuyValues.length ? arCanBuyValues[0] : allValues[0]);
						}
						else
						{
							arFilter[strName] = arCanBuyValues[0];
						}
					}

					this.updateRow(i, arFilter[strName], arShowValues, arCanBuyValues);
				}

				this.selectedValues = arFilter;
				this.changeInfo();
			}
		}

		updateRow(intNumber, activeId, showId, canBuyId)
		{
			var i = 0,
				value = '',
				isCurrent = false,
				rowItems = null;

			var lineContainer = this.getEntities(this.obTree, 'sku-line-block');

			if (intNumber > -1 && intNumber < lineContainer.length)
			{
				var rowItemsLast;
				rowItems = lineContainer[intNumber].querySelectorAll('li');
				for (i = 0; i < rowItems.length; i++)
				{
					value = rowItems[i].getAttribute('data-onevalue');
					isCurrent = value === activeId;

					if (isCurrent)
					{
						BX.addClass(rowItems[i], 'checked');
					}
					else
					{
						BX.removeClass(rowItems[i], 'checked');
					}

					if (BX.util.in_array(value, canBuyId))
					{
						BX.removeClass(rowItems[i], 'disabled');
					}
					else
					{
						BX.addClass(rowItems[i], 'disabled');
					}

					// rowItems[i].style.display = BX.util.in_array(value, showId) ? '' : 'none';
					BX.removeClass(rowItems[i], 'last-visible');
					if (BX.util.in_array(value, showId))
					{
						rowItemsLast = rowItems[i];
						rowItems[i].style.display = '';
					}
					else
					{
						rowItems[i].style.display = 'none';
					}

					if (isCurrent)
					{
						lineContainer[intNumber].style.display = (value == 0 && canBuyId.length == 1) ? 'none' : '';

						this.setOfferCurrentValue(lineContainer[intNumber], rowItems[i]);
					}
				}

				if (rowItemsLast)
				{
					BX.addClass(rowItemsLast, 'last-visible');
				}
			}
		}

		getRowValues(arFilter, index)
		{
			var arValues = [],
				i = 0,
				j = 0,
				boolSearch = false,
				boolOneSearch = true;

			if (arFilter.length === 0)
			{
				for (i = 0; i < this.offers.length; i++)
				{
					if (!BX.util.in_array(this.offers[i].TREE[index], arValues))
					{
						arValues[arValues.length] = this.offers[i].TREE[index];
					}
				}
				boolSearch = true;
			}
			else
			{
				for (i = 0; i < this.offers.length; i++)
				{
					boolOneSearch = true;

					for (j in arFilter)
					{
						if (arFilter[j] !== this.offers[i].TREE[j])
						{
							boolOneSearch = false;
							break;
						}
					}

					if (boolOneSearch)
					{
						if (!BX.util.in_array(this.offers[i].TREE[index], arValues))
						{
							arValues[arValues.length] = this.offers[i].TREE[index];
						}

						boolSearch = true;
					}
				}
			}

			return (boolSearch ? arValues : false);
		}

		getCanBuy(arFilter)
		{
			var i,
				j = 0,
				boolOneSearch = true,
				boolSearch = false;

			for (i = 0; i < this.offers.length; i++)
			{
				boolOneSearch = true;

				for (j in arFilter)
				{
					if (arFilter[j] !== this.offers[i].TREE[j])
					{
						boolOneSearch = false;
						break;
					}
				}

				if (boolOneSearch)
				{
					if (this.offers[i].CAN_BUY)
					{
						boolSearch = true;
						break;
					}
				}
			}

			return boolSearch;
		}

		setCurrent()
		{
			var i,
				j = 0,
				strName = '',
				arShowValues = false,
				arCanBuyValues = [],
				arFilter = {},
				tmpFilter = [],
				current = this.offers[this.offerNum].TREE;

			for (i = 0; i < this.treeProps.length; i++)
			{
				strName = 'PROP_' + this.treeProps[i].ID;
				arShowValues = this.getRowValues(arFilter, strName);

				if (!arShowValues)
					break;

				if (BX.util.in_array(current[strName], arShowValues))
				{
					arFilter[strName] = current[strName];
				}
				else
				{
					arFilter[strName] = arShowValues[0];
					this.offerNum = 0;
				}

				if (this.config.showAbsent)
				{
					arCanBuyValues = [];
					tmpFilter = [];
					tmpFilter = BX.clone(arFilter, true);

					for (j = 0; j < arShowValues.length; j++)
					{
						tmpFilter[strName] = arShowValues[j];

						if (this.getCanBuy(tmpFilter))
						{
							arCanBuyValues[arCanBuyValues.length] = arShowValues[j];
						}
					}
				}
				else
				{
					arCanBuyValues = arShowValues;
				}

			}

			this.selectedValues = arFilter;
		}

		changeInfo()
		{
			var index = -1,
				j = 0,
				boolOneSearch = true,
				eventData = {
					currentId: (this.offerNum > -1 ? this.offers[this.offerNum].ID : 0),
					newId: 0
				};

			var i, offerGroupNode;

			for (i = 0; i < this.offers.length; i++)
			{
				boolOneSearch = true;

				for (j in this.selectedValues)
				{
					if (this.selectedValues[j] !== this.offers[i].TREE[j])
					{
						boolOneSearch = false;
						break;
					}
				}

				if (boolOneSearch)
				{
					index = i;
					break;
				}
			}

			if (index > -1)
			{
				if (index != this.offerNum)
				{
					this.isGift = false;
				}

				this.updateSlider(this.offers[index].SLIDER);

				//sets
				for (i = 0; i < this.offers.length; i++)
				{
					if (this.config.showOfferGroup && this.offers[i].OFFER_GROUP)
					{
						if (offerGroupNode = BX(this.visual.OFFER_GROUP + this.offers[i].ID))
						{
							offerGroupNode.style.display = (i == index ? '' : 'none');
						}
					}
				}

				if (this.config.showSkuDescription === 'Y')
				{
					this.changeSkuDescription(index);
				}

				if (this.config.showSkuProps)
				{
					if (this.obSkuProps)
					{
						if (!this.offers[index].DISPLAY_PROPERTIES)
						{
							BX.adjust(this.obSkuProps, {style: {display: 'none'}, html: ''});
						}
						else
						{
							BX.adjust(this.obSkuProps, {style: {display: ''}, html: this.offers[index].DISPLAY_PROPERTIES});
						}
					}

					if (this.obMainSkuProps)
					{
						if (!this.offers[index].DISPLAY_PROPERTIES_MAIN_BLOCK)
						{
							BX.adjust(this.obMainSkuProps, {style: {display: 'none'}, html: ''});
						}
						else
						{
							BX.adjust(this.obMainSkuProps, {style: {display: ''}, html: this.offers[index].DISPLAY_PROPERTIES_MAIN_BLOCK});
						}
					}
				}

				if (this.offers[index].PROPERTIES && typeof this.offers[index].PROPERTIES === 'object')
				{
					for (var code in this.offers[index].PROPERTIES)
					{
						var arProp = this.offers[index].PROPERTIES[code];

						if (arProp.VALUE.length > 0)
						{
							var obProp = this.getEntity(this.obProduct, 'sku-prop-'+ arProp.ID);
							if (obProp)
							{
								BX.adjust(obProp, {html: arProp.VALUE});
							}
						}
					}
				}

				this.quantitySet(index);
				this.setPrice();
				this.setCompared(this.offers[index].COMPARED);

				this.offerNum = index;
				this.setAnalyticsDataLayer('showDetail');
				this.incViewedCounter();

				eventData.newId = this.offers[this.offerNum].ID;
				// only for compatible catalog.store.amount custom templates
				BX.onCustomEvent('onCatalogStoreProductChange', [this.offers[this.offerNum].ID]);
				// new event
				BX.onCustomEvent('onCatalogElementChangeOffer', [eventData]);
				eventData = null;

				this.setCartStatus();

				if (this.obSaleBanner && this.offers[this.offerNum].TIMER)
				{
					this.setTimer(this.offers[this.offerNum].TIMER);
				}
			}
		}

		changeSkuDescription(index)
		{
			var currentPreviewText = '';
			var currentDetailText = '';

			if (this.obDescription)
			{
				if (this.offers[index].DETAIL_TEXT !== '')
				{
					currentDetailText = this.offers[index].DETAIL_TEXT_TYPE === 'html' ? this.offers[index].DETAIL_TEXT : '<p>' + this.offers[index].DETAIL_TEXT + '</p>';
				}
				else if (this.product.detailText !== '')
				{
					currentDetailText = this.product.detailTextType === 'html' ? this.product.detailText : '<p>' + this.product.detailText + '</p>';
				}

				if (currentDetailText !== '')
				{
					BX.adjust(this.obDescription, {html: currentDetailText});
				}
			}

			if (this.obPreviewText)
			{
				if (this.offers[index].PREVIEW_TEXT !== '')
				{
					currentPreviewText = this.offers[index].PREVIEW_TEXT_TYPE === 'html' ? this.offers[index].PREVIEW_TEXT : '<p>' + this.offers[index].PREVIEW_TEXT + '</p>';
				}
				else if (this.product.previewText !== '')
				{
					currentPreviewText = this.product.previewTextType === 'html' ? this.product.previewText : '<p>' + this.product.previewText + '</p>';
				}

				if (
					currentPreviewText !== ''
					&& (
						this.config.displayPreviewTextMode === 'S'
						|| (this.config.displayPreviewTextMode === 'E' && currentDetailText)
					)
				)
				{
					BX.adjust(this.obPreviewText, {html: currentPreviewText});
				}
			}
		}

		drawImages(images)
		{
			if (!this.node.imageContainer)
				return;

			var i, slides, entities = this.getEntities(this.node.imageContainer, 'image')
			for (i in entities)
			{
				if (entities.hasOwnProperty(i) && BX.type.isDomNode(entities[i]))
				{
					BX.remove(entities[i]);
				}
			}

			slides = this.getSlides(images);

			for (i = 0; i < slides.length; i++)
			{
				this.node.imageContainer.appendChild(slides[i]);
			}
		}

		getSlides(images)
		{
			var i, img, slides = [];

			for (i = 0; i < images.length; i++)
			{
				img = BX.create('IMG', {
					props: {
						src: images[i].RESIZE ? images[i].RESIZE.big.src : images[i].SRC,
						alt: this.config.alt,
						title: this.config.title
					}
				});

				if (i == 0)
				{
					img.setAttribute('itemprop', 'image');
				}

				slides.push(BX.create('DIV', {
					attrs: {
						'data-entity': 'image',
						'data-index': i+'',
						'data-thumb': images[i].RESIZE ? images[i].RESIZE.small.src : images[i].SRC,
					},
					props: {
						className: 'swiper-slide',
					},
					children: [
						BX.create('DIV', {
							props: {
								className: 'product-item-slider-image' + (i == 0 ? ' active' : '')
							},
							children: [img]
						})
					]
				}));
			}

			return slides;
		}


		updateSlider(images)
		{
			if (!this.product.slider.instance)
				return;

			var slides = this.getSlides(images);

			const { instance } = this.product.slider;


			instance.removeAllSlides();

			instance.appendSlide(slides)
			instance.slideTo(1, 0);
		}

		restoreSticker()
		{
			if (this.previousStickerText)
			{
				this.redrawSticker({text: this.previousStickerText});
			}
			else
			{
				this.hideSticker();
			}
		}

		hideSticker()
		{
			BX.hide(BX(this.visual.STICKER_ID));
		}

		redrawSticker(stickerData)
		{
			stickerData = stickerData || {};
			var text = stickerData.text || '';

			var sticker = BX(this.visual.STICKER_ID);
			if (!sticker)
				return;

			BX.show(sticker);

			var previousStickerText = sticker.getAttribute('title');
			if (previousStickerText && previousStickerText != text)
			{
				this.previousStickerText = previousStickerText;
			}

			BX.adjust(sticker, {text: text, attrs: {title: text}});
		}

		checkQuantityRange(quantity, direction)
		{
			if (typeof quantity === 'undefined'|| this.currentPriceMode !== 'Q')
			{
				return quantity;
			}

			quantity = parseFloat(quantity);

			var nearestQuantity = quantity;
			var range, diffFrom, absDiffFrom, diffTo, absDiffTo, shortestDiff;

			for (var i in this.currentQuantityRanges)
			{
				if (this.currentQuantityRanges.hasOwnProperty(i))
				{
					range = this.currentQuantityRanges[i];

					if (
						parseFloat(quantity) >= parseFloat(range.SORT_FROM)
						&& (
							range.SORT_TO === 'INF'
							|| parseFloat(quantity) <= parseFloat(range.SORT_TO)
						)
					)
					{
						nearestQuantity = quantity;
						break;
					}
					else
					{
						diffFrom = parseFloat(range.SORT_FROM) - quantity;
						absDiffFrom = Math.abs(diffFrom);
						diffTo = parseFloat(range.SORT_TO) - quantity;
						absDiffTo = Math.abs(diffTo);

						if (shortestDiff === undefined || shortestDiff > absDiffFrom)
						{
							if (
								direction === undefined
								|| (direction === 'up' && diffFrom > 0)
								|| (direction === 'down' && diffFrom < 0)
							)
							{
								shortestDiff = absDiffFrom;
								nearestQuantity = parseFloat(range.SORT_FROM);
							}
						}

						if (shortestDiff === undefined || shortestDiff > absDiffTo)
						{
							if (
								direction === undefined
								|| (direction === 'up' && diffFrom > 0)
								|| (direction === 'down' && diffFrom < 0)
							)
							{
								shortestDiff = absDiffTo;
								nearestQuantity = parseFloat(range.SORT_TO);
							}
						}
					}
				}
			}

			return nearestQuantity;
		}

		checkPriceRange(quantity)
		{
			if (typeof quantity === 'undefined'|| this.currentPriceMode !== 'Q')
			{
				return;
			}

			var range, found = false;

			for (var i in this.currentQuantityRanges)
			{
				if (this.currentQuantityRanges.hasOwnProperty(i))
				{
					range = this.currentQuantityRanges[i];

					if (
						parseFloat(quantity) >= parseFloat(range.SORT_FROM)
						&& (
							range.SORT_TO === 'INF'
							|| parseFloat(quantity) <= parseFloat(range.SORT_TO)
						)
					)
					{
						found = true;
						this.currentQuantityRangeSelected = range.HASH;
						break;
					}
				}
			}

			if (!found && (range = this.getMinPriceRange()))
			{
				this.currentQuantityRangeSelected = range.HASH;
			}

			for (var k in this.currentPrices)
			{
				if (this.currentPrices.hasOwnProperty(k))
				{
					if (this.currentPrices[k].QUANTITY_HASH == this.currentQuantityRangeSelected)
					{
						this.currentPriceSelected = k;
						break;
					}
				}
			}
		}

		getMinPriceRange()
		{
			var range;

			for (var i in this.currentQuantityRanges)
			{
				if (this.currentQuantityRanges.hasOwnProperty(i))
				{
					if (
						!range
						|| parseInt(this.currentQuantityRanges[i].SORT_FROM) < parseInt(range.SORT_FROM)
					)
					{
						range = this.currentQuantityRanges[i];
					}
				}
			}

			return range;
		}

		checkQuantityControls()
		{
			if (!this.obQuantity)
				return;

			var reachedTopLimit = this.checkQuantity && parseFloat(this.obQuantity.value) + this.stepQuantity > this.maxQuantity,
				reachedBottomLimit = parseFloat(this.obQuantity.value) - this.stepQuantity < this.minQuantity;

			if (reachedTopLimit)
			{
				BX.addClass(this.obQuantityUp, 'product-item-amount-field-btn-disabled');
			}
			else if (BX.hasClass(this.obQuantityUp, 'product-item-amount-field-btn-disabled'))
			{
				BX.removeClass(this.obQuantityUp, 'product-item-amount-field-btn-disabled');
			}

			if (reachedBottomLimit)
			{
				BX.addClass(this.obQuantityDown, 'product-item-amount-field-btn-disabled');
			}
			else if (BX.hasClass(this.obQuantityDown, 'product-item-amount-field-btn-disabled'))
			{
				BX.removeClass(this.obQuantityDown, 'product-item-amount-field-btn-disabled');
			}

			if (reachedTopLimit && reachedBottomLimit)
			{
				this.obQuantity.setAttribute('disabled', 'disabled');
			}
			else
			{
				this.obQuantity.removeAttribute('disabled');
			}
		}

		setPrice()
		{
			var economyInfo = '', price, i, j;

			if (this.obQuantity)
			{
				this.checkPriceRange(this.obQuantity.value);
			}

			this.checkQuantityControls();

			price = this.currentPrices[this.currentPriceSelected];

			if (!!this.config.fillAllPrices && this.currentAllPrices != undefined)
			{
				var arRange = this.currentAllPrices[this.currentPriceSelected];
				if (arRange)
				{
					var priceNodes = this.getEntities(this.obProduct, 'price');

					for (j in priceNodes)
					{
						if (priceNodes.hasOwnProperty(j) && BX.type.isDomNode(priceNodes[j]))
						{
							for (i in arRange.PRICES)
							{
								var arPrice = arRange.PRICES[i];

								if (arPrice.PRICE_TYPE_ID === priceNodes[j].getAttribute('data-price-id'))
								{
									priceNodes[j].style.display = '';
									this.updatePrice(priceNodes[j], arPrice);
									break;
								}
								else
								{
									priceNodes[j].style.display = 'none';
								}

							}
						}
					}

				}
			}
			else
			{
				var priceNode = this.getEntity(this.obProduct, 'price');
				this.updatePrice(priceNode, price);
			}

			if (this.obPrice.total)
			{
				if (price && this.obQuantity && this.obQuantity.value != this.stepQuantity)
				{
					BX.adjust(this.obPrice.total, {
						html: BX.message('PRICE_TOTAL_PREFIX') + ': <span class="price-total-value">'
						+ (
							this.productType == 0
								? price.CURRENCY.replace('#', BX.util.number_format(price.PRICE * this.obQuantity.value, 0, '.', ' '))
								: BX.Currency.currencyFormat(price.PRICE * this.obQuantity.value, price.CURRENCY, true)
							)
						+ '</span>',
						style: {display: ''}
					});
				}
				else
				{
					BX.adjust(this.obPrice.total, {
						html: '',
						style: {display: 'none'}
					});
				}
			}
		}

		updatePrice(obPriceRow, price)
		{
			var economyInfo = '',
				priceHtml = '',
				obPriceCurrent = this.getEntity(obPriceRow, 'price-current'),
				obPriceFull = this.getEntity(obPriceRow, 'price-full'),
				obPriceDiscount = this.getEntity(obPriceRow, 'price-discount'),
				obPriceCashBack = this.getEntity(obPriceRow, 'cashback');
x

			if (this.isGift)
			{
				price.PRICE = 0;
				price.DISCOUNT = price.BASE_PRICE;
				price.PERCENT = 100;
			}

			if (obPriceCurrent)
			{
				if (price)
				{
					priceHtml = BX.message('CATALOG_PRICE_UNITS')
						.replace('#PRICE#', this.productType == 0 ? price.PRINT_RATIO_PRICE : BX.Currency.currencyFormat(price.RATIO_PRICE, price.CURRENCY, true))
						.replace('#VALUE#', this.minQuantity == 1 ? '' : this.minQuantity)
						.replace('#UNIT#', this.productType == 3 ? this.offers[this.offerNum].MEASURE : this.product.measure);

					BX.adjust(obPriceCurrent, {html: priceHtml});
/*
					this.smallCardNodes.price && BX.adjust(this.smallCardNodes.price, {
						html: BX.Currency.currencyFormat(price.RATIO_PRICE, price.CURRENCY, true)
					});
*/
				}
				else
				{
					BX.adjust(obPriceCurrent, {html: ''});
/*
					this.smallCardNodes.price && BX.adjust(this.smallCardNodes.price, {html: ''});
*/
				}

				if (price && price.RATIO_PRICE !== price.RATIO_BASE_PRICE)
				{
					if (this.config.showOldPrice)
					{
						priceHtml = BX.message('CATALOG_PRICE_UNITS')
							.replace('#PRICE#', this.productType == 0 ? price.PRINT_RATIO_BASE_PRICE : BX.Currency.currencyFormat(price.RATIO_BASE_PRICE, price.CURRENCY, true))
							.replace('#VALUE#', this.minQuantity == 1 ? '' : this.minQuantity)
							.replace('#UNIT#', this.productType == 3 ? this.offers[this.offerNum].MEASURE : this.product.measure);

						obPriceFull && BX.adjust(obPriceFull, {
							style: {display: ''},
							html: priceHtml
						});
/*
						this.smallCardNodes.oldPrice && BX.adjust(this.smallCardNodes.oldPrice, {
							style: {display: ''},
							html: BX.Currency.currencyFormat(price.RATIO_BASE_PRICE, price.CURRENCY, true)
						});
*/

						if (obPriceDiscount)
						{
							economyInfo = BX.message('ECONOMY_INFO_MESSAGE');
							economyInfo = economyInfo.replace('#ECONOMY#', this.productType == 0 ? price.PRINT_RATIO_DISCOUNT : BX.Currency.currencyFormat(price.RATIO_DISCOUNT, price.CURRENCY, true));
							BX.adjust(obPriceDiscount, {style: {display: ''}, html: economyInfo});
						}
					}
				}
				else
				{
					if (this.config.showOldPrice)
					{
						obPriceFull && BX.adjust(obPriceFull, {style: {display: 'none'}, html: ''});
/*
						this.smallCardNodes.oldPrice && BX.adjust(this.smallCardNodes.oldPrice, {style: {display: 'none'}, html: ''});
*/
						obPriceDiscount && BX.adjust(obPriceDiscount, {style: {display: 'none'}, html: ''});
					}
				}

				if (obPriceCashBack)
				{
					if (price.RATIO_BONUS > 0)
					{
						obPriceCashBack.style.display = '';
						this.getEntity(obPriceCashBack, 'cashback-value').innerHTML = this.productType == 0
							? price.CURRENCY.replace('#', BX.util.number_format(price.RATIO_BONUS * this.obQuantity.value, 0, '.', ' '))
							: BX.Currency.currencyFormat(price.RATIO_BONUS * this.obQuantity.value, price.CURRENCY, true);
					}
					else
					{
						obPriceCashBack.style.display = 'none';
					}
				}
			}
		}

		compare(event)
		{
			var checkbox = this.obCompare.querySelector('[data-entity="compare-checkbox"]'),
				target = BX.getEventTarget(event),
				checked = true;

			if (checkbox)
			{
				checked = target === checkbox ? checkbox.checked : !checkbox.checked;
			}

			var url = checked ? this.compareData.compareUrl : this.compareData.compareDeleteUrl,
				compareLink;

			if (url)
			{
				if (target !== checkbox)
				{
					BX.PreventDefault(event);
					this.setCompared(checked);
				}

				switch (this.productType)
				{
					case 0: // no catalog
					case 1: // product
					case 2: // set
						compareLink = url.replace('#ID#', this.product.id.toString());
						break;
					case 3: // sku
						compareLink = url.replace('#ID#', this.offers[this.offerNum].ID);
						break;
				}

				BX.ajax({
					method: 'POST',
					dataType: checked ? 'json' : 'html',
					url: compareLink + (compareLink.indexOf('?') !== -1 ? '&' : '?') + 'ajax_action=Y',
					onsuccess: checked
						? BX.proxy(this.compareResult, this)
						: BX.proxy(this.compareDeleteResult, this)
				});
			}
		}

		compareResult(result)
		{
			var popupContent, popupAlert, popupButtons, popupButton;
/*
			if (this.obPopupWin)
			{
				this.obPopupWin.hide();
			}
*/
			if (!BX.type.isPlainObject(result))
				return;

			if (this.offers.length > 0)
			{
				this.offers[this.offerNum].COMPARED = result.STATUS === 'OK';
			}

			if (result.STATUS === 'OK')
			{
				store.dispatch(ActionCreators.addItemToCompare(parseInt(result.ID, 10)));
				BX.onCustomEvent('OnCompareChange', [{'action': 'add', 'id': result.ID}]);
				Popover.show(this.obCompare);
			}
			else
			{
				this.initPopupWindow();
				if (this.obPopupWin.isShowed())
					this.obPopupWin.disable();
				else
					this.obPopupWin.addBackdrop().startLoader();

				popupContent = document.createDocumentFragment();

				popupAlert = document.createElement('div');
				popupAlert.classList.add('alert', 'alert-danger', 'mb-4');
				popupAlert.innerHTML = (result.MESSAGE ? result.MESSAGE : BX.message('COMPARE_UNKNOWN_ERROR'));
				popupContent.appendChild(popupAlert);

				popupButtons = document.createElement('div');
				popupButtons.classList.add('text-center');

				popupButton = document.createElement('button')
				popupButton.classList.add('btn', 'btn-primary');
				popupButton.innerHTML = BX.message('BTN_MESSAGE_CLOSE');
				popupButton.addEventListener('click', (event) => {
					this.obPopupWin.hide();
				});
				popupButtons.appendChild(popupButton);

				popupContent.appendChild(popupButtons);

				this.obPopupWin.title = BX.message('COMPARE_TITLE');
				this.obPopupWin.body = popupContent;

				if (this.obPopupWin.isShowed())
					this.obPopupWin.enable();
				else
					this.obPopupWin.show().endLoader();
			}
		}

		compareDeleteResult(result)
		{
			result = BX.parseJSON(result);
			if (result.STATUS === 'OK')
			{
				store.dispatch(ActionCreators.removeItemFromCompare(parseInt(result.ID, 10)));
				BX.onCustomEvent('OnCompareChange', [{'action': 'delete', 'id': result.ID}]);
			}

			if (this.offers && this.offers.length)
			{
				this.offers[this.offerNum].COMPARED = false;
			}
		}

		setCompareStatus(id)
		{
			switch (this.productType)
			{
				case 0: // no catalog
				case 1: // product
				case 2: // set
				case 4: // element from sku iblock
					if (this.product.id == id)
					{
						this.setCompared(store.state.compare.addedIds.has(parseInt(this.product.id, 10)));
					}
					break;

				case 3: // sku
					var i = this.offers.length;
					while (i--)
					{
						if (this.offers[i].ID == id)
						{
							this.offers[i].COMPARED = store.state.compare.addedIds.has(parseInt(this.offers[i].ID, 10));

							if (this.offerNum == i)
							{
								this.setCompared(store.state.compare.addedIds.has(parseInt(this.offers[this.offerNum].ID, 10)));
							}

							break;
						}
					}
			}
		}

		setCompared(state)
		{
			if (!this.obCompare)
				return;

			if (state)
			{
				BX.addClass(this.obCompare, 'checked');

				var popupContent = '<p class="mb-2">' + BX.message('COMPARE_MESSAGE_OK') + '</p>'
					+ '<a href="'+ this.compareData.comparePath +'">'+ BX.message('BTN_MESSAGE_COMPARE_REDIRECT') +'</a>';

				this.addPopover(this.obCompare, popupContent);
			}
			else
			{
				this.removePopover(this.obCompare);
				BX.removeClass(this.obCompare, 'checked');
			}

			var checkbox = this.obCompare.querySelector('[data-entity="compare-checkbox"]');
			if (checkbox)
			{
				checkbox.checked = state;
			}

			var compareText = this.obCompare.querySelector('[data-entity="compare-title"]');
			if (compareText)
			{
				compareText.innerHTML = state
					? this.mess.MESS_BTN_COMPARE_DEL
					: this.mess.MESS_BTN_COMPARE_ADD;
			}
		}

		setCompareInfo(comparedIds)
		{
			if (!BX.type.isArray(comparedIds))
				return;

			for (var i in this.offers)
			{
				if (this.offers.hasOwnProperty(i))
				{
					this.offers[i].COMPARED = BX.util.in_array(this.offers[i].ID, comparedIds);
				}
			}
		}

		compareRedirect()
		{
			if (this.compareData.comparePath)
			{
				location.href = this.compareData.comparePath;
			}
			else
			{
				this.obPopupWin.close();
			}
		}

		checkDeletedCompare(id)
		{
			switch (this.productType)
			{
				case 0: // no catalog
				case 1: // product
				case 2: // set
					if (this.product.id == id)
					{
						this.setCompared(false);
					}

					break;
				case 3: // sku
					var i = this.offers.length;
					while (i--)
					{
						if (this.offers[i].ID == id)
						{
							this.offers[i].COMPARED = false;

							if (this.offerNum == i)
							{
								this.setCompared(false);
							}

							break;
						}
					}
			}
		}

		initBasketUrl()
		{
			this.basketUrl = (this.basketMode === 'ADD' ? this.basketData.add_url : this.basketData.buy_url);

			switch (this.productType)
			{
				case 1: // product
				case 2: // set
					this.basketUrl = this.basketUrl.replace('#ID#', this.product.id.toString());
					break;
				case 3: // sku
					this.basketUrl = this.basketUrl.replace('#ID#', this.offers[this.offerNum].ID);
					break;
			}

			this.basketParams = {
				'ajax_basket': 'Y'
			};

			if (this.config.showQuantity)
			{
				this.basketParams[this.basketData.quantity] = this.obQuantity.value;
			}

			if (this.basketData.sku_props)
			{
				this.basketParams[this.basketData.sku_props_var] = this.basketData.sku_props;
			}
		}

		fillBasketProps()
		{
			if (!this.visual.BASKET_PROP_DIV)
				return;

			var
				i = 0,
				propCollection = null,
				foundValues = false,
				obBasketProps = null;

			if (this.basketData.useProps && !this.basketData.emptyProps)
			{
				if (this.obPopupWin)
				{
					obBasketProps = this.obPopupWin.body;
				}
			}
			else
			{
				obBasketProps = BX(this.visual.BASKET_PROP_DIV);
			}

			if (obBasketProps)
			{
				propCollection = obBasketProps.getElementsByTagName('select');
				if (propCollection && propCollection.length)
				{
					for (i = 0; i < propCollection.length; i++)
					{
						if (!propCollection[i].disabled)
						{
							switch (propCollection[i].type.toLowerCase())
							{
								case 'select-one':
									this.basketParams[propCollection[i].name] = propCollection[i].value;
									foundValues = true;
									break;
								default:
									break;
							}
						}
					}
				}

				propCollection = obBasketProps.getElementsByTagName('input');
				if (propCollection && propCollection.length)
				{
					for (i = 0; i < propCollection.length; i++)
					{
						if (!propCollection[i].disabled)
						{
							switch (propCollection[i].type.toLowerCase())
							{
								case 'hidden':
									this.basketParams[propCollection[i].name] = propCollection[i].value;
									foundValues = true;
									break;
								case 'radio':
									if (propCollection[i].checked)
									{
										this.basketParams[propCollection[i].name] = propCollection[i].value;
										foundValues = true;
									}
									break;
								default:
									break;
							}
						}
					}
				}
			}

			if (!foundValues)
			{
				this.basketParams[this.basketData.props] = [];
				this.basketParams[this.basketData.props][0] = 0;
			}
		}

		sendToBasket()
		{
			if (!this.canBuy)
				return;

			switch (this.productType)
			{
				case 0: // no catalog
					if (this.config.showQuantity) {
						Basket.add(this.product.id, this.obQuantity.value);
					} else {
						Basket.add(this.product.id, 1);
					}
					this.basketResult({
						'STATUS': 'OK',
					});
					break;
				case 1: // product
				case 2: // set
				case 3: // sku
					this.enableAddToBasketLoading();
					this.initBasketUrl();
					this.fillBasketProps();
					BX.ajax({
						method: 'POST',
						dataType: 'json',
						url: this.basketUrl,
						data: this.basketParams,
						onsuccess: BX.proxy(this.basketResult, this)
					});
					break;
			}
		}

		add2Basket()
		{
			this.basketMode = 'ADD';
			this.basket();
		}

		buyBasket()
		{
			this.basketMode = 'BUY';
			this.basket();
		}

		basket()
		{
			if (!this.canBuy)
				return;

			switch (this.productType)
			{
				case 1: // product
				case 2: // set
					if (this.basketData.useProps && !this.basketData.emptyProps)
					{
						this.initPopupWindow();
						if (this.obPopupWin.isShowed())
							this.obPopupWin.disable();
						else
							this.obPopupWin.addBackdrop().startLoader();

						var popupContent, popupButtons, popupButton;
						popupContent = document.createDocumentFragment();

						var obBasketProp = document.getElementById(this.visual.BASKET_PROP_DIV);

						if (obBasketProp)
						{
							var popupProps = document.createElement('div');
							popupProps.classList.add('mb-4');
							popupProps.innerHTML = obBasketProp.innerHTML;

							popupContent.appendChild(popupProps);
						}

						popupButtons = document.createElement('div');
						popupButtons.classList.add('text-center');

						popupButton = document.createElement('button')
						popupButton.classList.add('btn', 'btn-primary');
						popupButton.innerHTML = BX.message('BTN_SEND_PROPS');
						popupButton.addEventListener('click', (event) => {
							this.sendToBasket();
						});
						popupButtons.appendChild(popupButton);

						popupContent.appendChild(popupButtons);

						this.obPopupWin.title = BX.message('TITLE_BASKET_PROPS');
						this.obPopupWin.body = popupContent;

						if (this.obPopupWin.isShowed())
							this.obPopupWin.enable();
						else
							this.obPopupWin.show().endLoader();
					}
					else
					{
						this.sendToBasket();
					}
					break;
				case 0: // no catalog
				case 3: // sku
					this.sendToBasket();
					break;
			}
		}

		basketResult(arResult)
		{
			var popupContent, popupAlert, popupButtons, popupButton, productPict, successful;

			this.disableAddToBasketLoading();
/*
			if (this.obPopupWin)
			{
				this.obPopupWin.hide();
			}
*/
			if (!BX.type.isPlainObject(arResult))
				return;

			successful = arResult.STATUS === 'OK';

			if (successful)
			{
				this.setAnalyticsDataLayer('addToCart');
			}

			if (successful && this.basketMode === 'BUY')
			{
				this.basketRedirect();
			}
			else
			{
				if (successful)
				{
					this.obPopupWin && this.obPopupWin.hide();

					var productId, quantity;
					switch (this.productType)
					{
						case 3: // sku
							productId = parseInt(this.offers[this.offerNum].ID, 10);
							break;
						default:
							productId = parseInt(this.product.id, 10);
							break;
					}

					quantity = this.basketParams[this.basketData.quantity]
						? this.basketParams[this.basketData.quantity]
						: 1;

					store.dispatch(ActionCreators.addItemToCart(
						productId,
						parseInt(quantity, 10))
					);

					BX.onCustomEvent('OnBasketChange', [{}, 'ADD2CART']);

					if	(BX.findParent(this.obProduct, {className: 'bx_sale_gift_main_products'}, 10))
					{
						BX.onCustomEvent('onAddToBasketMainProduct', [this]);
					}
				}
				else
				{
					this.initPopupWindow();
					if (this.obPopupWin.isShowed())
						this.obPopupWin.disable();
					else
						this.obPopupWin.addBackdrop().startLoader();

					popupContent = document.createDocumentFragment();

					popupAlert = document.createElement('div');
					popupAlert.classList.add('alert', 'alert-danger', 'mb-4');
					popupAlert.innerHTML = arResult.MESSAGE ? arResult.MESSAGE : BX.message('BASKET_UNKNOWN_ERROR');
					popupContent.appendChild(popupAlert);

					popupButtons = document.createElement('div');
					popupButtons.classList.add('text-center');

					popupButton = document.createElement('button')
					popupButton.classList.add('btn', 'btn-primary');
					popupButton.innerHTML = BX.message('BTN_MESSAGE_CLOSE');
					popupButton.addEventListener('click', (event) => {
						this.obPopupWin.hide();
					});
					popupButtons.appendChild(popupButton);

					popupContent.appendChild(popupButtons);

					this.obPopupWin.title = arResult.STATUS === 'OK' ? BX.message('TITLE_SUCCESSFUL') : BX.message('TITLE_ERROR');
					this.obPopupWin.body = popupContent;

					if (this.obPopupWin.isShowed())
						this.obPopupWin.enable();
					else
						this.obPopupWin.show().endLoader();
				}
			}
		}

		basketRedirect()
		{
			location.href = (this.basketData.basketUrl ? this.basketData.basketUrl : BX.message('BASKET_URL'));
		}

		offerInit(offer)
		{

			this.canBuy = offer.CAN_BUY;

			this.currentPriceMode = offer.ITEM_PRICE_MODE;
			this.currentPrices = offer.ITEM_PRICES;
			this.currentAllPrices = offer.ITEM_ALL_PRICES;
			this.currentPriceSelected = offer.ITEM_PRICE_SELECTED;
			this.currentQuantityRanges = offer.ITEM_QUANTITY_RANGES;
			this.currentQuantityRangeSelected = offer.ITEM_QUANTITY_RANGE_SELECTED;

			this.isDblQuantity = offer.QUANTITY_FLOAT;
			this.checkQuantity = offer.CHECK_QUANTITY;

			if (this.isDblQuantity)
			{
				this.stepQuantity = Math.round(parseFloat(offer.STEP_QUANTITY) * this.precisionFactor) / this.precisionFactor;
				this.maxQuantity = parseFloat(offer.MAX_QUANTITY);
				this.minQuantity = this.currentPriceMode === 'Q' ? parseFloat(this.currentPrices[this.currentPriceSelected].MIN_QUANTITY) : this.stepQuantity;
			}
			else
			{
				this.stepQuantity = parseInt(offer.STEP_QUANTITY, 10);
				this.maxQuantity = parseInt(offer.MAX_QUANTITY, 10);
				this.minQuantity = this.currentPriceMode === 'Q' ? parseInt(this.currentPrices[this.currentPriceSelected].MIN_QUANTITY) : this.stepQuantity;
			}

			this.slides = offer.SLIDER;
		}

		initPopupWindow()
		{
			if (store.state.ui.modal.activeId)
			{
				this.obPopupWin = Modal.getInstanceById(store.state.ui.modal.activeId);
			}
			else
			{
				this.obPopupWin = new Modal();
			}
		}

		incViewedCounter()
		{
			if (this.currentIsSet && !this.updateViewedCount)
			{
				switch (this.productType)
				{
					case 1:
					case 2:
						this.viewedCounter.params.PRODUCT_ID = this.product.id;
						this.viewedCounter.params.PARENT_ID = this.product.id;
						break;
					case 3:
						this.viewedCounter.params.PARENT_ID = this.product.id;
						this.viewedCounter.params.PRODUCT_ID = this.offers[this.offerNum].ID;
						break;
					default:
						return;
				}

				this.viewedCounter.params.SITE_ID = BX.message('SITE_ID');
				this.updateViewedCount = true;
				BX.ajax.post(
					this.viewedCounter.path,
					this.viewedCounter.params,
					BX.delegate(function()
					{
						this.updateViewedCount = false;
					}, this)
				);
			}
		}

		allowViewedCount(update)
		{
			this.currentIsSet = true;

			if (update)
			{
				this.incViewedCounter();
			}
		}

/*
		fixFontCheck()
		{
			if (BX.type.isDomNode(this.obPrice.price))
			{
				BX.FixFontSize && BX.FixFontSize.init({
					objList: [{
						node: this.obPrice.price,
						maxFontSize: 28,
						smallestValue: false,
						scaleBy: this.obPrice.price.parentNode
					}],
					onAdaptiveResize: true
				});

			}
		}
*/

		enableAddToBasketLoading()
		{
			if (this.obAddToBasketBtn)
			{
				this.obAddToBasketBtn.classList.add('btn-loading', 'disabled');
			}

			this.obPopupWin && this.obPopupWin.disable();
		}

		disableAddToBasketLoading()
		{
			if (
				this.obAddToBasketBtn &&
				this.obAddToBasketBtn.classList.contains('btn-loading')
			) {
				this.obAddToBasketBtn.classList.remove('btn-loading', 'disabled');
			}

			this.obPopupWin && this.obPopupWin.enable();
		}

		setOfferCurrentValue(offerProp, offerValue)
		{
			var currentValueNodes = this.getEntities(offerProp, 'sku-current-value');
			for (var j in currentValueNodes)
			{
				if (currentValueNodes.hasOwnProperty(j) && BX.type.isDomNode(currentValueNodes[j]))
				{
					currentValueNodes[j].innerHTML = offerValue.getAttribute('title');
				}
			}
		}

		setCartStatus()
		{
			if (this.obBasketActions)
			{
				var productID;

				switch (this.productType)
				{
					case 3: // sku
						productID = parseInt(this.offers[this.offerNum].ID);
						break;
					default:
						productID = parseInt(this.product.id);
						break;
				}

				if (store.state.cart.addedIds.has(productID))
				{
					BX.addClass(this.obBasketActions, 'is-incart');
					if (this.obBuyBtn)
					{
						this.obBuyBtn.innerHTML = this.mess.MESS_BTN_INCART
							.replace('#NUM#', store.state.cart.quantityByIds[productID]);
					}
					if (this.obAddToBasketBtn)
					{
						this.obAddToBasketBtn.innerHTML = this.mess.MESS_BTN_INCART
							.replace('#NUM#', store.state.cart.quantityByIds[productID]);
					}
				}
				else
				{
					BX.removeClass(this.obBasketActions, 'is-incart');
					if (this.obBuyBtn)
					{
						this.obBuyBtn.innerHTML = this.mess.MESS_BTN_BUY;
					}
					if (this.obAddToBasketBtn)
					{
						this.obAddToBasketBtn.innerHTML = this.mess.MESS_BTN_ADD_TO_BASKET;
					}
				}
			}
		}

		favoriteAction(event)
		{
			BX.PreventDefault(event);

			var params = {
				element_id: parseInt(this.product.id, 10),
			}, action;

			action = store.state.wishlist.addedIds.has(parseInt(this.product.id, 10))
				? 'remove' : 'add';

			BX.ajax.runComponentAction(
				'redsign:favorite.list', action, {
					mode: 'class',
					data: {post: params},
				})
			.then((response) => {
				if (response.status === 'success')
				{
					this.favoriteResult(response.data);
				}
			});
		}

		favoriteResult(arResult)
		{
			var successful;

			if (!BX.type.isPlainObject(arResult))
				return;

			successful = arResult.STATUS === 'OK';

			if (successful)
			{
				switch(arResult.ACTION)
				{
					case 'ADD':
						store.dispatch(ActionCreators.addItemToWishlist(parseInt(this.product.id, 10)));
						Popover.show(this.obFavorite);

						break;

					case 'REMOVE':
						store.dispatch(ActionCreators.removeItemFromWishlist(parseInt(this.product.id, 10)));

						break;
				}
			}
		}

		setFavoriteStatus()
		{
			if (!this.obFavorite)
				return;

			var obFavoriteText = this.obFavorite.querySelector('[data-entity="favorite-title"]'),
				state = store.state.wishlist.addedIds.has(parseInt(this.product.id, 10));
				//obFavoriteCount = BX.findChild(this.obFavorite, {'className': 'favorite__cnt'}, true);

			if (state)
			{
				BX.addClass(this.obFavorite, 'checked');
				if (!!obFavoriteText)
				{
					obFavoriteText.innerHTML = this.mess.MESS_BTN_FAVORITE_DEL;
				}

				var popupContent = '<p class="mb-2">' + BX.message('FAVORITE_MESSAGE_OK') + '</p>'
						+ '<a href="'+ this.favoriteData.favoritePath +'">'+ BX.message('BTN_MESSAGE_FAVORITE_REDIRECT') +'</a>';

				this.addPopover(this.obFavorite, popupContent);
			}
			else
			{
				BX.removeClass(this.obFavorite, 'checked');
				this.removePopover(this.obFavorite);

				if (!!obFavoriteText)
				{
					obFavoriteText.innerHTML = this.mess.MESS_BTN_FAVORITE_ADD;
				}
			}
		}

		addPopover(node, content)
		{
			new Popover (node, this.visual.COMPARE_LINK_ID, {
				placement : 'top',
				trigger : 'manual',
				sanitize: false,
				html : true,
				content: content,
				delay: { show: 500, hide: 1500 },
			});

			node.addEventListener('mouseenter', BX.proxy(this.onPopoverFocus, this));
			node.addEventListener('mouseleave', BX.proxy(this.onPopoverBlur, this));
			node.addEventListener('focusin', BX.proxy(this.onPopoverFocus, this));
			node.addEventListener('focusout', BX.proxy(this.onPopoverBlur, this));
			node.addEventListener('keydown', BX.proxy(this.onPopoverKeydown, this));

			$(node).on('inserted.bs.popover', (event) => {

				const { target } = event;

				var popupId = target.getAttribute('aria-describedby'),
				popup = document.getElementById(popupId);

				popup.addEventListener(
					'keydown',
					(event) => {

						if (event.code === 'Escape' || event.code === 'Esc')
						{
							node.focus();
						}
					},
					true
				);
			});
		}

		removePopover(node)
		{
			Popover.dispose(node);
			node.removeEventListener('mouseenter',  BX.proxy(this.onPopoverFocus, this));
			node.removeEventListener('mouseleave',  BX.proxy(this.onPopoverBlur, this));
			node.removeEventListener('focusin',  BX.proxy(this.onPopoverFocus, this));
			node.removeEventListener('focusout',  BX.proxy(this.onPopoverBlur, this));
			node.removeEventListener('keydown',  BX.proxy(this.onPopoverKeydown, this));
		}

		onPopoverFocus(event)
		{
			if (this.itemPopoverShown)
				return;

			const { target } = event;

			Popover.show(target);

			this.itemPopoverShown = true;
		}

		onPopoverBlur(event)
		{
			const { target } = event;
			var popover;

			if (event.type == 'focusout')
			{
				popover = BX.findParent(event.toElement, { className: 'popover'});
			}
			else if (event.type == 'mouseleave')
			{
				popover = BX.findParent(event.toElement, { className: 'popover'});
			}

			if (popover)
			{
				popover.addEventListener('mouseleave', BX.proxy(function(event){

					Popover.hide(target);

				}, this), { once: true});

				return;
			}

			Popover.hide(target);
			this.itemPopoverShown = false;
		}

		onPopoverKeydown(event)
		{
			const { target } = event;

			switch(event.code)
			{
				case 'ArrowUp':
					if (!target.getAttribute('aria-describedby'))
					{
						Popover.show(target);
					}

					var popupId = target.getAttribute('aria-describedby'),
						popup = document.getElementById(popupId);

					popup.querySelector('.popover-body a').focus();

					break;

				case 'Escape':
				case 'Esc':
					event.preventDefault();
					Popover.hide(target);
					break;
			}
		}

		showFeedbackForm(event)
		{
			var target = BX.proxy_context,
				data = {},
				productID;

			BX.PreventDefault(event);

			switch (this.productType)
			{
				case 3: // sku
					productID = this.offers[this.offerNum].ID;
					break;
				default:
					productID = this.product.id;
					break;
			}

			const modal = Modal.load(
				BX.util.add_url_param(this.feedbackData.feedbackPath, data),
				{
					method: 'POST'
				},
				{
					backurl: location.href,
				}
			)

			modal.subscribe(Modal.Events.AFTER_INSERTED, ({ data: { instance } }) => {
				const field = instance.body.querySelector('[data-field-sid="ELEMENT"]');
				if (field)
				{
					field.readOnly = true;
					field.setAttribute('value', this.product.name);
				}
			});

			modal.subscribe(Modal.Events.HIDDEN, ({ data: { instance } }) => {
				instance.dispose();
			});
		}

		buy1Click(event)
		{
			if (!this.canBuy)
				return;

			var target = BX.proxy_context,
				data = {},
				productID;

			BX.PreventDefault(event);

			switch (this.productType)
			{
				case 3: // sku
					productID = this.offers[this.offerNum].ID;
					break;
				default:
					productID = this.product.id;
					break;
			}

			if (this.config.showQuantity)
				data['QUANTITY_' + productID] = this.obQuantity.value;
			else if (this.currentPriceMode === 'Q')
				data['QUANTITY_' + productID] = parseFloat(this.currentPrices[this.currentPriceSelected].MIN_QUANTITY);
			else
				data['QUANTITY_' + productID] = this.stepQuantity;

			const modal = Modal.load(
				BX.util.add_url_param(target.getAttribute('href'), data),
				{
					title: BX.message('BTN_MESSAGE_BUY1CLICK'),
					method: 'POST'
				},
				{

					RS_ORDER_IDS: data,
					backurl: location.href,
				}
			)

			modal.subscribe(Modal.Events.HIDDEN, () => {
				modal.dispose();
			});
		}
}
